{
  "common.add": "+ Add",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.delete": "Delete",
  "common.done": "Done",
  "common.edit": "Edit",
  "common.exportCsv": "Export CSV",
  "common.loading": "Loading…",
  "common.refresh": "Refresh",
  "common.retry": "Retry",
  "common.loadFailed": "Couldn’t load — check your connection.",
  "common.howThisWorks": "How this works",
  "err.readOnly": "Your plan is read-only — Subscribe in Billing.",
  "err.denied": "You don’t have permission to do that.",
  "err.offline": "No connection — try again.",
  "err.generic": "Something went wrong — text 604 722 0685 for help.",
  "err.alreadySubscribed": "You already have a subscription — change it with Manage in Stripe.",
  "err.noSubscription": "There is no active subscription to change — subscribe first.",
  "err.adminOnly": "Only an admin can change billing.",
  "err.invalidSeats": "Enter 1 seat or more.",
  "common.save": "Save",
  "common.unitOne": "unit",
  "common.unitMany": "units",
  "common.signOut": "Sign Out",
  "common.themeToDark": "Switch to dark theme",
  "common.themeToLight": "Switch to light theme",
  "ca.title": "Corrective Actions",
  "ca.subtitle": "Deficiencies turned into owned, dated actions. The assignee gets an email on assignment, works it from \"My Actions\" in the field app, and closes it with a note. Overdue actions are emailed daily to your corrective-action recipients.",
  "ca.listTitle": "Actions",
  "ca.newBtn": "+ New action",
  "ca.stOpen": "Open",
  "ca.stOverdue": "Overdue",
  "ca.stClosed": "Closed",
  "ca.stAll": "All",
  "ca.allAssignees": "All assignees",
  "ca.prLow": "Low",
  "ca.prMedium": "Medium",
  "ca.prHigh": "High",
  "ca.due": "Due",
  "ca.closedOn": "Closed {date}",
  "ca.source": "Source:",
  "ca.emptyList": "No actions here. Create one, or open a form in Submissions and click Raise action.",
  "ca.overdueDaysOne": "Overdue 1 day",
  "ca.overdueDaysMany": "Overdue {days} days",
  "ca.createTitle": "New Corrective Action",
  "ca.descLabel": "What needs to be corrected? *",
  "ca.descPh": "e.g. Replace damaged guardrail on the north stairwell",
  "ca.assigneeLabel": "Assign to *",
  "ca.dueLabel": "Due date *",
  "ca.priorityLabel": "Priority",
  "ca.projectLabel": "Project",
  "ca.noProject": "— No project —",
  "ca.createBtn": "Create & notify",
  "ca.descRequired": "Describe what needs to be corrected.",
  "ca.assigneeRequired": "Pick who owns this action.",
  "ca.dueRequired": "Pick a due date.",
  "ca.closeTitle": "Close Action",
  "ca.closeNoteLabel": "What was done? *",
  "ca.closeNotePh": "e.g. Guardrail replaced and inspected",
  "ca.closeBtn": "Close action",
  "ca.noteRequired": "A closure note is required.",
  "ca.close": "Close",
  "ca.reopen": "Reopen",
  "ca.deleteConfirm": "Delete this corrective action? This cannot be undone.",
  "cr.title": "Compliance",
  "cr.subtitle": "A per-project compliance report for your GC or an auditor: safety-form coverage measured against days your crew actually worked, corrective actions, and the signed evidence trail.",
  "cr.projectLabel": "Project",
  "cr.pickProject": "— Select project —",
  "cr.pickProjectFirst": "Pick a project first.",
  "cr.periodLabel": "Period",
  "cr.presetThisMonth": "This month",
  "cr.presetLastMonth": "Last month",
  "cr.presetLast30": "Last 30 days",
  "cr.presetCustom": "Custom",
  "cr.fromLabel": "From",
  "cr.toLabel": "To",
  "cr.runBtn": "Run report",
  "cr.running": "Running…",
  "cr.badRange": "Pick a valid date range.",
  "cr.pdfBtn": "Summary PDF",
  "cr.bundleBtn": "Evidence zip",
  "cr.kpiTailgate": "Daily Tailgate coverage",
  "cr.kpiToolbox": "Toolbox Talk coverage",
  "cr.kpiHours": "Hours logged",
  "cr.kpiHoursSub": "from timesheet entries",
  "cr.kpiSigned": "Signed records",
  "cr.kpiSignedSub": "locked at signing, of all forms in period",
  "cr.kpiCa": "Corrective actions open",
  "cr.caOpened": "opened",
  "cr.caClosed": "closed in period",
  "cr.caOverdue": "overdue now",
  "cr.caNoneOverdue": "none overdue",
  "cr.kpiCerts": "Certs expired / expiring",
  "cr.kpiCertsSub": "expired / expiring within 30 days",
  "cr.certOrgWideNote": "organization-wide — not project-scoped",
  "cr.ofActiveDays": "{hit} of {total} active days",
  "cr.ofActiveWeeks": "{hit} of {total} active weeks",
  "cr.noActiveDays": "no days with logged hours in period",
  "cr.ringKick": "Overall safety coverage",
  "cr.ringCovered": "Covered",
  "cr.ringHit": "hit {covered} of {total} required safety touchpoints in this range.",
  "cr.ringNote": "Daily tailgates on active days + weekly toolbox talks on active weeks — the tiles below break it down.",
  "cr.ringEmpty": "No activity",
  "cr.ringEmptyLine": "No logged work in this range yet.",
  "cr.ringEmptyNote": "Coverage counts once time is logged or a tailgate comes in for this project and date range.",
  "cr.pillOnTrack": "On track",
  "cr.pillAttention": "Needs attention",
  "cr.packTitle": "Evidence pack",
  "cr.reportTitle": "Project report",
  "cr.evidenceShort": "Evidence",
  "cr.packBody": "Bundle every signed record, inspection and cert for a project into one branded zip — ready for the GC or a COR/ISO audit.",
  "cr.countsTitle": "Forms submitted",
  "cr.colType": "Form type",
  "cr.colCount": "Count",
  "cr.colTotal": "Total",
  "cr.noForms": "No forms submitted in this period.",
  "cr.evidenceTitle": "Evidence — signed records & PDFs",
  "cr.evidenceCap": "Showing the first 200 of {total} records — narrow the period to see the rest.",
  "cr.noPdf": "no PDF",
  "cr.pdfOpenFailed": "Could not open the PDF: {message}",
  "cr.bundling": "Building zip…",
  "cr.bundleFailed": "Could not build the evidence bundle: {message}",
  "cr.runFirst": "Pick a project and run the report.",
  "billing.currentPlan": "Current plan",
  "billing.wouldCost": "Your crew today would cost",
  "billing.perYear": "year",
  "billing.perMonth": "month",
  "billing.seatLine": "{seats} seat{s} × {rate}/mo · {foremen} {fs} + {admins} admin{as} in use · workers free",
  "billing.tiersTitle": "Volume pricing",
  "billing.tiersSub": "The rate drops as the crew grows — applied automatically at checkout. Annual is ten months for twelve.",
  "billing.tier1": "1–4 seats",
  "billing.tier2": "5–14 seats",
  "billing.tier3": "15+ seats",
  "billing.tierYours": "your band today",
  "billing.tierPerSeat": "per seat, per month",
  "billing.includesPendingOne": "includes 1 pending invite",
  "billing.includesPendingMany": "includes {n} pending invites",
  "billing.complimentary": "Complimentary plan — no charge",
  "billing.complimentaryDetail": "Ordinex covers this company's seats — nothing is billed and there is nothing to subscribe to.",
  "billing.compSeatLine": "{used} of {seats} seats in use · {foremen} {fs} + {admins} admin{as} · workers free",
  "billing.badgeTrial": "Trial",
  "billing.badgeLeftOne": "1 day left",
  "billing.badgeLeftMany": "{days} days left",
  "billing.badgeEnded": "Trial ended",
  "billing.trialEmailLimit": "Free trial: up to 20 e-mails a day.",
  "billing.trialEmailSent": "Free trial: up to 20 e-mails a day — {n} sent today.",
  "billing.adminCount": "{n} admins",
  "billing.seatLimitRole": "Admins and foremen each use one seat — this change needs another seat. Add seats in the Billing tab first.",
  "plan.readOnlyAdmin": "Your plan is inactive — the app is read-only. Open Admin Panel → Billing to reactivate.",
  "plan.readOnlyWorker": "Your organization's plan is inactive — forms are read-only. Ask your admin to reactivate.",
  "plan.paywallBanner": "Your plan is inactive — the field app is read-only.",
  "plan.paywallCta": "Subscribe to reactivate →",
  "plan.sheetTrial": "Your company's free trial has ended. Forms are read-only until your office subscribes — nothing is deleted.",
  "plan.sheetTrialAdmin": "Your company's free trial has ended. Forms are read-only until you subscribe — nothing is deleted.",
  "plan.sheetInactive": "Your company's subscription is not active. Forms are read-only until your office reactivates it — nothing is deleted.",
  "plan.sheetInactiveAdmin": "Your company's subscription is not active. Forms are read-only until you reactivate it in Billing — nothing is deleted.",
  "billing.title": "Billing",
  "billing.subtitle": "One seat per person who creates documents — foreman or admin, same price. Workers are free and unlimited. Volume pricing: CA$69/seat (1–4), $59 (5–14), $49 (15+) per month; annual = 2 months free.",
  "billing.subscription": "Subscription",
  "billing.noBilling": "No billing on file",
  "billing.noBillingDetail": "No billing plan on file for this organization.",
  "billing.trialNoEnd": "Free trial",
  "billing.trialLeftOne": "Free trial — 1 day left",
  "billing.trialLeftMany": "Free trial — {days} days left",
  "billing.trialDetail": "No card required during the trial — up to 10 seats while you evaluate. Subscribe below to keep the crew going after it ends.",
  "billing.trialExpired": "Trial expired — read-only",
  "billing.trialExpiredDetail": "Field forms are read-only until you subscribe. All your history stays visible and downloadable.",
  "billing.active": "Active",
  "billing.seatsLineOne": "1 seat",
  "billing.seatsLineMany": "{seats} seats",
  "billing.billedMonthly": "billed monthly",
  "billing.billedAnnually": "billed annually",
  "billing.renews": "renews {date}",
  "billing.cancelsAtEnd": "cancels at period end",
  "billing.pastDue": "Payment past due",
  "billing.pastDueDetail": "The last payment failed — everything keeps working while Stripe retries. Update your card in Manage billing.",
  "billing.paused": "Paused — read-only",
  "billing.canceled": "Cancelled — read-only",
  "billing.inactiveDetail": "Field forms are read-only. Subscribe again to reactivate — all data is intact.",
  "billing.seatOverage": "Seat overage: you have more foremen and admins than paid seats. New invites are blocked — add seats below. Existing logins are never affected.",
  "billing.seatsInUse": "Seats in use:",
  "billing.paidSuffix": "/ {seats} paid",
  "billing.subscribe": "Subscribe",
  "billing.manage": "Manage",
  "billing.billingLabel": "Billing",
  "billing.monthly": "Monthly",
  "billing.annual": "Annual — 2 months free",
  "billing.foremanSeats": "Seats",
  "billing.seats": "Seats (foremen + admins)",
  "billing.subscribeBtn": "Subscribe →",
  "billing.subscribeNote": "You'll enter payment details on Stripe's secure checkout. Seats can be changed any time — adding charges the rest of the month right away, removing credits your next invoice.",
  "billing.manageBtn": "Manage in Stripe",
  "billing.updateSeats": "Update seats",
  "billing.updating": "Updating…",
  "billing.openingCheckout": "Opening checkout…",
  "billing.prorateNoteOne": "Adding seats charges the rest of this month right away; removing them credits your next invoice. You can't go below your 1 seat in use.",
  "billing.prorateNoteMany": "Adding seats charges the rest of this month right away; removing them credits your next invoice. You can't go below your {used} seats in use.",
  "billing.errSeatsBelow": "Seat count is below your current foremen + admins + pending invites.",
  "billing.errPortal": "Could not open the billing portal.",
  "billing.openingPortal": "Opening the Stripe billing portal…",
  "billing.exportTitle": "Export all your data",
  "billing.exportDesc": "A ZIP with every record — one spreadsheet per type of record — plus a download link for every stored file, signed PDFs included. The links work for 7 days; for an audit, use the Evidence zip on Compliance.",
  "billing.exportBtn": "Download ZIP",
  "billing.exporting": "Preparing export… this can take a minute",
  "billing.exportErr": "Export failed — try again or contact support.",
  "billing.exportDone": "Export downloaded — check your downloads folder.",
  "st.orgTitle": "Organization",
  "st.brandTitle": "Brand",
  "st.brandSub": "Your logo and colours go on every PDF the crews sign — the paperwork carries your brand, not ours. The app itself always wears Ordinex.",
  "st.jurTitle": "Jurisdiction",
  "st.jurSub": "Decides which regulator is cited on inspection forms. It never changes what crews fill out — only the citation line on the paper.",
  "st.noticeTitle": "Regulatory wording",
  "st.noticeSub": "This exact wording prints on your inspection PDFs. Ordinex seeds a starting point with its source cited — the final say is your company's. Edit a line to use your own wording; clear it to go back to the seeded text.",
  "st.noticeNote": "Your wording wins over the seeded text",
  "st.rolesTitle": "Seats & logins",
  "st.dataTitle": "Your data",
  "st.exportTitle": "Take your data with you",
  "st.exportSub": "One ZIP: every record as a spreadsheet, plus download links to your stored files that work for 7 days. For an audit, use the Evidence zip on Compliance.",
  "st.cancelTitle": "Cancel subscription",
  "st.cancelSub": "Managed through the Stripe billing portal — seats, invoices and cancellation.",
  "st.supportTitle": "Support",
  "st.supportSub": "Email support@ordinex.ca — a human replies within 1 business day. A crew that cannot file a form, or a login that fails on site: text or call 604 722 0685, 6:00–18:00 Pacific, Monday to Saturday — fixed the same day.",
  "st.closeTitle": "Close your account",
  "st.closeSub": "Signed forms can’t be changed, so closing an account is handled with support: support@ordinex.ca.",
  "billing.paymentInvoices": "Payment & invoices",
  "billing.stripeOwns": "Stripe stores your card and your full invoice history — nothing payment-related is kept here.",
  "packs.title": "Trade Packs",
  "packs.stackTitle": "Packs stack — run as many as your crews need",
  "packs.subtitle": "Packs stack: each adds its trade’s safety tasks, checklists and forms to the standard set. Removing a pack only switches it off — its forms, materials and history come back if you add it again.",
  "packs.imported": "Imported",
  "packs.flagOnly": "Enabled (legacy) — import to materialize",
  "packs.reimport": "Re-import (new version)",
  "packs.importing": "Importing…",
  "packs.importErr": "Import failed: {message}",
  "packs.empty": "No packs published yet.",
  "packs.noneTitle": "No trade pack selected",
  "packs.noneHint": "Your crews are running the standard forms. Select your trade to load its safety content, quality checks and forms.",
  "packs.select": "Select trade pack →",
  "packs.currentBadge": "Active",
  "packs.pickerTitle": "Add a trade pack",
  "packs.pickerSub": "Packs stack — adding one keeps every pack already active. Close this window to see the full active list, where any pack can be removed. Submissions and form history are always kept.",
  "packs.selectThis": "Add this pack →",
  "packs.materialize": "Import to materialize →",
  "packs.activeTitle": "Active trade packs",
  "packs.addPack": "Add trade pack",
  "packs.removeBtn": "Remove",
  "packs.removeTitle": "Remove {pack}?",
  "packs.removeBody": "Nothing is deleted — forms, materials and history are kept; the pack’s forms just leave the app. You can add it back anytime.",
  "packs.removeGo": "Remove pack",
  "packs.replaceTitle": "Update {pack} forms",
  "packs.replaceIntro": "These forms will be updated to the latest pack version:",
  "packs.replaceCustomIntro": "These forms were customized by you. Check the ones you want to OVERWRITE (unchecked ones keep your version):",
  "packs.replaceGo": "Import",
  "packs.skippedNote": "Kept your customized version of: {list}",
  "packs.cancel": "Cancel",
  "fb.title": "Forms",
  "fb.subtitle": "Customize your organization's forms — reorder fields, edit labels and options, add your own fields, and tune the safety content your crews see. Signed records always keep the exact version they were filled with.",
  "fb.stateDefault": "Default",
  "fb.stateCustom": "Customized · v{v}",
  "fb.stateDraft": "Draft",
  "fb.editingDraft": "Editing draft — not visible to crews until published",
  "fb.fields": "fields",
  "fb.edit": "Edit",
  "fb.showToCrews": "Show to crews",
  "fb.empty": "No forms found.",
  "fb.back": "All forms",
  "fb.fieldsTitle": "Fields",
  "fb.addField": "Add field",
  "fb.editField": "Edit field",
  "fb.removeField": "Remove field",
  "fb.removeConfirm": "Remove \"{label}\"? Data already submitted with this field stays intact — only new submissions change.",
  "fb.protected": "This field is required for signed records and can't be removed.",
  "fb.compositeLocked": "Built-in block — its content is editable below, but the block itself can't be removed.",
  "fb.fieldType": "Field type",
  "fb.fieldLabel": "Label *",
  "fb.fieldPlaceholder": "Placeholder",
  "fb.fieldOptions": "Options (one per line) *",
  "fb.fieldRequired": "Required",
  "fb.labelRequired": "A label is required.",
  "fb.optionsRequired": "Choice fields need at least one option.",
  "fb.cancel": "Cancel",
  "fb.saveField": "Save field",
  "fb.saveDraft": "Save draft",
  "fb.publish": "Publish",
  "fb.publishConfirm": "Publish this version? Crews get it the next time they open the app. Existing signed records are never changed.",
  "fb.discard": "Discard draft",
  "fb.discardConfirm": "Discard this draft? Your published version (or the default) stays as is.",
  "fb.history": "History",
  "fb.historyEmpty": "No versions yet — this form still uses the system default.",
  "fb.historySourcePack": "Pack: {pack}",
  "fb.historySourceBuilder": "Form Builder",
  "fb.restore": "Restore",
  "fb.restoreConfirm": "Restore version {v} as a new draft? Review it in the editor, then Publish to make it live. Your current unsaved draft (if any) is replaced.",
  "fb.reset": "Reset to default",
  "fb.resetConfirm": "Reset this form to the default? Your customizations are retired (old records keep the version they were signed with).",
  "fb.saveErr": "Could not save: {message}",
  "fb.propagation": "Changes reach crews the next time they open the app. Published versions are never edited in place — publishing creates a new version and signed records keep the one they were filled with.",
  "fb.livePreview": "Live form",
  "fb.canvasSub": "What the crew sees",
  "fb.pdfPreview": "PDF preview",
  "fb.pdfError": "Couldn't build the PDF preview.",
  "fb.retry": "Retry",
  "fb.rendersInApp": "Shown in the app",
  "fb.selectHint": "Select a field to edit it.",
  "fb.showIf": "Show only if",
  "fb.always": "Always show",
  "fb.equals": "equals",
  "fb.help": "Help text",
  "fb.placeholder": "Placeholder",
  "fb.required": "Required to submit",
  "fb.options": "Options (one per line)",
  "fb.editContentBelow": "Edit this block's content below.",
  "fb.duplicate": "Duplicate",
  "fb.duplicateForm": "Duplicate",
  "fb.newFieldLabel": "New field",
  "fb.palText": "Short text",
  "fb.palEmail": "Email",
  "fb.palPhone": "Phone",
  "fb.palPhoto": "Photo",
  "fb.palParagraph": "Paragraph",
  "fb.palNumber": "Number",
  "fb.palDate": "Date",
  "fb.palChoice": "Single choice",
  "fb.palChecklist": "Check all that apply",
  "fb.palDropdown": "Dropdown",
  "fb.palSection": "Section",
  "fb.palStatusGrid": "Inspection grid",
  "fb.palTable": "Table",
  "fb.itemsLabel": "Items to inspect (one per line)",
  "fb.statusOptions": "Status options (one per line, 2–5)",
  "fb.colsLabel": "Columns (one per line)",
  "fb.colHint": "Start a line with # for a number column. Max 5 columns.",
  "fb.maxRows": "Max rows",
  "fb.halfWidth": "Half width (pairs with the next half-width field)",
  "fb.tailgateTitle": "Daily Tailgate — items reviewed",
  "fb.tailgateHint": "sections and checklist items on the morning meeting form",
  "fb.checkedDefault": "Checked by default",
  "fb.addItem": "Add item",
  "fb.addSection": "Add section",
  "fb.newSection": "New section",
  "fb.removeSection": "Remove section",
  "fb.removeSectionConfirm": "Remove this section and all its items?",
  "fb.flraTitle": "FLRA — task hazard library",
  "fb.flraHint": "tasks crews pick from, with hazards, risk and controls pre-filled",
  "fb.preselected": "Included by default",
  "fb.controls": "Controls (how the risk is managed)",
  "fb.addTask": "Add task",
  "fb.flraVocab": "Hazard vocabulary",
  "fb.toolboxTitle": "Toolbox Talk — hazard review rows",
  "fb.qaqcTitle": "QAQC — inspection checklist",
  "fb.qaqcStagesTitle": "Field QAQC — staged checklists",
  "fb.qaqcStagesHint": "items per stage; stages themselves are fixed",
  "fb.closeoutTitle": "Close-out questions",
  "fb.newForm": "New form",
  "fb.newFormSub": "A custom form for your organization — starts with a details field and a signature; add your own fields in the editor.",
  "fb.newIcon": "Icon",
  "fb.newTitle": "Form name *",
  "fb.newDesc": "Short description",
  "fb.titleRequired": "Give the form a name (at least 3 characters).",
  "fb.keyTaken": "A form with this name already exists.",
  "fb.create": "Create form",
  "fb.deleteForm": "Delete form",
  "fb.deleteFormConfirm": "Delete this custom form? It disappears from the field app; records already submitted with it are kept.",
  "notif.title": "Notifications",
  "notif.subtitle": "Who receives each email your organization sends. An event with nobody listed goes to every admin’s login email.",
  "notif.deliveryTitle": "Delivery",
  "notif.recipientsByEvent": "Who gets notified",
  "notif.settings": "Settings",
  "notif.weeklyToggle": "Weekly summary email (Sundays)",
  "notif.replyTo": "Reply-to address",
  "notif.replyToPlaceholder": "defaults to your company email",
  "notif.replyToInvalid": "Enter a valid reply-to email (or leave it empty).",
  "notif.recent": "Recently sent",
  "notif.recentSub": "Last 20 emails. Any still waiting are retried automatically every few minutes.",
  "notif.nothingSent": "Nothing sent yet.",
  "notif.fallbackNote": "No recipients configured — all admins receive this.",
  "notif.remove": "Remove",
  "notif.addFailed": "Could not add recipient: {message}",
  "notif.removeFailed": "Could not remove recipient: {message}",
  "notif.colWhen": "When",
  "notif.colEvent": "Event",
  "notif.colTo": "To",
  "notif.colSubject": "Subject",
  "notif.colStatus": "Status",
  "notif.statusSent": "✓ sent",
  "notif.statusQueued": "… queued",
  "notif.statusFailed": "✗ failed",
  "notif.statusHeld": "Held — trial daily limit",
  "notif.evSafetyForm": "Safety form submitted",
  "notif.evSafetyFormDesc": "Signed form PDF from the field (per-project CSO is added on top)",
  "notif.evDeliveryNew": "New delivery request",
  "notif.evDeliveryNewDesc": "When a foreman requests a delivery",
  "notif.evExtraWork": "Extra Work Order",
  "notif.evExtraWorkDesc": "When an EWO is submitted and needs pricing",
  "notif.evWeekly": "Weekly summary",
  "notif.evWeeklyDesc": "The Sunday digest of hours, production and pending items",
  "notif.evCorrective": "Corrective actions",
  "notif.evCorrectiveDesc": "The daily digest of overdue corrective actions (assignment emails always go to the assignee)",
  "notif.evCompliance": "Monthly compliance",
  "notif.evComplianceDesc": "First of the month: last month's per-project compliance snapshot",
  "notif.evCertExpiring": "Expiring certifications",
  "notif.evCertExpiringDesc": "Daily: worker certifications lapsing within 30 days (also sent as a push notification)",
  "notif.evDeliveryStatus": "Delivery status update",
  "notif.evSalusForward": "Forwarded to Salus Pro",
  "fb.noticeTitle": "Signed records never change",
  "fb.crumb": "Settings · Forms",
  "fb.canvasHint": "Drag to reorder · click to edit",
  "fb.dragHint": "Drag to reorder",
  "fb.conditional": "conditional",
  "fb.condNote": "Shows only when \"{field}\" equals {value}",
  "fb.protectedName": "Protected — this one can't be renamed",
  "fb.helpHint": "Shown under the field in the app",
  "fb.onePerLine": "One per line",
  "fb.palFoot": "New fields land just above the signature block — the natural end of the form.",
  "fb.pdfLive": "updates as you type",
  "fb.pdfFoot": "Rendered by the same generator your crews' signed PDFs use — with your logo and colours.",
  "fb.sheetFieldRows": "Rows are filled by the crew on site — sample layout shown",
  "fb.sheetBuiltinInspection": "This form uses the app's built-in inspection checklist",
  "fb.viewPdf": "View PDF",
  "fb.undo": "Undo",
  "fb.redo": "Redo",
  "fb.unsavedPrompt": "You have unsaved changes. Leave without saving?",
  "fb.pdfLoading": "Generating PDF…",
  "fb.labelRequired": "A field needs a printed label",
  "fb.wFull": "Full width",
  "fb.wTwoThirds": "2/3",
  "fb.wHalf": "1/2",
  "fb.wThird": "1/3",
  "fb.copyField": "Copy",
  "fb.copied": "Copied — paste with Ctrl+V",
  "fb.widthLabel": "Width on paper",
  "fb.minHLabel": "Writing space (mm)",
  "fb.fieldSettings": "Field settings",
  "fb.content": "Content",
  "fb.addOption": "Add option",
  "fb.addColumn": "Column",
  "fb.addTask": "Add task",
  "fb.addHazard": "Add hazard",
  "fb.addStage": "Add stage",
  "fb.addTgSection": "Add section",
  "fb.newLine": "New line",
  "fb.newSection": "New section",
  "fb.newTask": "New task",
  "fb.setRisk": "RISK",
  "fb.editContent": "Edit content…",
  "fb.newGroup": "Where it belongs",
  "fb.newGroupHint": "Sets where crews find it on their phone.",
  "fb.groupSafety": "Safety",
  "fb.groupInspections": "Inspections",
  "fb.groupProduction": "Site & Production",
  "fb.newSafetyEmail": "Email it to the safety inbox on submit",
  "fb.safetyInbox": "Safety inbox",
  "fb.moveUp": "Move up",
  "fb.moveDown": "Move down",
  "fb.tailLocked": "Sign-off blocks stay at the end of the document",
  "fb.addBefore": "Add a block above",
  "fb.addAfter": "Add a block below",
  "fb.removeSectionConfirm": "Remove the section \"{title}\" and its {n} lines from the talk?",
  "fb.historyTitle": "Version history",
  "fb.historyNote": "Nothing is ever overwritten — retired versions stay restorable",
  "fb.hcolVersion": "Version",
  "fb.hcolWho": "Saved by",
  "fb.hcolSource": "Source",
  "fb.hcolWhen": "Created",
  "fb.hcolStatus": "Status",
  "fb.stLive": "Live",
  "fb.stRetired": "Retired",
  "fb.removeItem": "Remove",
  "fb.tailgateCard": "Tailgate content",
  "fb.tailgateCardSub": "The checklist the crew signs off — sections, items, and what's ticked by default",
  "fb.countSections": "{n} sections · {i} items",
  "fb.countTasks": "{n} tasks · {h} hazards",
  "fb.countItems": "{n} items",
  "fb.countRows": "{n} rows",
  "fb.countQuestions": "{n} questions",
  "fb.countStages": "{n} stages · {i} items",
  "fb.toolboxHint": "The hazard rows the weekly toolbox talk walks through",
  "fb.qaqcHint": "The checklist rows on the QAQC form",
  "fb.closeoutHint": "Asked when the crew closes the day out",
  "jc.ratesBtn": "Labour rates",
  "jc.budgetBtn": "Set budget",
  "jc.budgetBtnView": "Budget",
  "jc.budgetTitle": "Project Budget",
  "jc.budgetInvalid": "Budgets must be zero or positive numbers.",
  "jc.budgetFromTasks": "Budgets on this project come from each task's takeoff on the Contract tab.",
  "jc.material": "Material",
  "jc.labour": "Labour",
  "jc.equipment": "Equipment",
  "jc.trucking": "Trucking",
  "jc.safety": "Safety",
  "jc.other": "Other",
  "jc.noTrucking": "No trucking costs entered for this project yet.",
  "jc.noSafety": "No safety costs entered for this project yet.",
  "jc.noOther": "Nothing here.",
  "jc.entryAddBtn": "Add cost",
  "jc.entryAddTitle": "Add Cost",
  "jc.entryEditTitle": "Edit Cost",
  "jc.entryHint": "For a cost with no delivery behind it — a trucking company's invoice, material bought at the counter, safety supplies, a dumpster. Type what you actually paid, subtotal + PST, leaving GST out. No tax is added on top.",
  "jc.entryCategory": "Goes under",
  "jc.entryRecipeWarn": "This project prices material from its cost recipe — this entry will show as $0.00 (not counted).",
  "jc.entryAmount": "Amount (before GST, PST included)",
  "jc.entryDate": "Date",
  "jc.entryNumber": "Invoice #",
  "jc.entryVendor": "Vendor",
  "jc.entryDesc": "Description",
  "jc.entryBadge": "invoice",
  "jc.rowInvoiceTitle": "{vendor} invoice #{number}",
  "jc.rowInvoiceNo": "Invoice #{number}",
  "jc.rowTypedInvoice": "Typed invoice",
  "jc.rowTypedCost": "Typed cost",
  "jc.entryBadAmount": "Enter an amount greater than zero.",
  "jc.noProjects": "No projects yet — create one on the All Projects tab.",
  "jc.hasBuildings": "This project has {n} sub-projects. This page is this project's own spend - the combined picture lives in P&L.",
  "jc.noBudget": "No budget set",
  "jc.notInBudget": "Not in the budget",
  "jc.overBy": "Over budget by {amt}",
  "jc.leftOf": "{left} left of {budget}",
  "jc.unitCostTitle": "Unit cost",
  "jc.unitCostHint": "What one unit cost to put in place, including the {pct}% overhead.",
  "jc.unitCostHintNoOverhead": "What one unit cost to put in place.",
  "jc.perSf": "per SF",
  "jc.perLf": "per LF",
  "jc.perUnit": "per {unit}",
  "jc.unitQty": "{qty} installed",
  "jc.unitQtyOf": "{qty} of {est} installed",
  "jc.unitUnaccounted": "{amount} ({pct}) of cost is not in any price above.",
  "jc.unitNoLines": "Add contract lines on the Contract tab to price each product.",
  "jc.statementTitle": "Statement",
  "jc.onOrder": "ordered — not delivered yet",
  "jc.onOrderSub": "not counted until it is set to Delivered on the Deliveries tab",
  "jc.onOrderNeeded": "needed by {date}",
  "jc.onOrderNoteOne": "1 order not delivered yet ({amt}) — not counted",
  "jc.onOrderNoteMany": "{n} orders not delivered yet ({amt}) — not counted",
  "jc.onOrderNoteBareOne": "1 order not delivered yet — not counted",
  "jc.onOrderNoteBareMany": "{n} orders not delivered yet — not counted",
  "jc.confirmed": "invoice",
  "jc.noPriceN": "{n} without price",
  "jc.noPrice": "no price",
  "jc.notInCatalogue": "not in your catalogue",
  "jc.ambiguousName": "name fits more than one catalogue item",
  "jc.noItems": "No items listed",
  "jc.noDeliveries": "No material entered yet. Deliveries and pickups count once they arrive; add supplier invoices with Add cost, under Material.",
  "jc.noHours": "No timesheet hours for this project yet.",
  "jc.noEquipment": "No equipment costs recorded for this project. They are managed on Rental costs.",
  "jc.noTrade": "No classification",
  "jc.noRate": "no rate set",
  "jc.labourDetail": "{workers} workers · {reg} regular + {ot} OT",
  "jc.labourDetailOne": "1 worker · {reg} regular + {ot} OT",
  "jc.labourByTimesheet": "by timesheet",
  "jc.otNote": "OT × 1.5",
  "jc.today": "today",
  "jc.equipDetail": "{days} days × {rate}/day",
  "jc.equipDetailOne": "1 day × {rate}/day",
  "jc.equipOverlapTag": "same name, overlapping dates",
  "jc.scaffoldTwoDoorsTyped": "scaffold also priced from Equipment › Rental",
  "jc.scaffoldTwoDoorsRented": "scaffold also typed as a rental",
  "eq.onSiteSince": "on site since {date}",
  "ec.moveNoProject": "A rental has to be on a project. Pick the project it is on — or use \"End rental\" if it went back.",
  "ec.moveConfirm": "Move \"{what}\" to {to} from today?\n\nThe {days} days it has already spent on {from} ({amount}) stay on {from}. {to} is charged from today.\n\nIf it was typed on the wrong project from the start, press Cancel, delete it and add it again on the right one.",
  "ec.moveConfirmOne": "Move \"{what}\" to {to} from today?\n\nThe 1 day it has already spent on {from} ({amount}) stays on {from}. {to} is charged from today.\n\nIf it was typed on the wrong project from the start, press Cancel, delete it and add it again on the right one.",
  "ec.otherProject": "the other project",
  "ec.linkToEquipment": "Rented equipment list is in Equipment →",
  "ec.linkToCosts": "Rental cost lines are in Rental costs →",
  "ec.addNote": "Leave the return date blank while it is still on rent. If you later change the rate or move it to another project, past days keep the rate and project they were billed at.",
  "jc.scaffoldUnpricedOne": "1 piece has no price on file",
  "jc.scaffoldUnpricedMany": "{n} pieces have no price on file",
  "jc.scaffoldUnpricedNamed": "{name} has no price on file",
  "jc.scaffoldUndatedOne": "1 piece has no start date on file",
  "jc.scaffoldUndatedNamed": "{name} has no start date on file",
  "jc.scaffoldUndatedMany": "{n} pieces have no start date on file",
  "jc.scaffoldNoSiteCode": "No site code set — can't match rented equipment",
  "jc.scaffoldCantTell": "can't tell",
  "jc.scaffoldNoSiteCodeDetail": "This project has no site code set, so Ordinex can't match it to rented scaffold in Equipment › Rental. Set the site code on All Projects to see this cost.",
  "jc.scaffoldDetail": "{qty} on site · {days} days × {rate}/day",
  "jc.scaffoldDetailOne": "{qty} on site · 1 day × {rate}/day",
  "jc.scaffoldNoStart": "no start date on file",
  "jc.scaffoldNoDateDetail": "{qty} on site — no start date on file, can't price",
  "jc.scaffoldNoDateOpen": "Open this row to set it.",
  "jc.scaffoldUnnamed": "Unnamed piece",
  "jc.scafGroupTitle": "Scaffold · {n} pieces",
  "jc.scafGroupSub": "{from} → {to} · open to see each piece",
  "jc.freightFoldTitle": "Freight from the price book",
  "jc.freightFoldSub": "{from} → {to} · open to see each delivery and its task",
  "jc.scafDateTitle": "On site since",
  "jc.scafDateLabel": "The day it arrived on this project",
  "jc.scafDateHint": "This row costs the days it has been on site × quantity × its daily rate, so the date decides how much of it this project pays. Changing it also changes the months it falls in: a period or a PDF you already printed will read differently next time.",
  "jc.scafDateAllOne": "Also change the 1 other row on this project that starts on {date}",
  "jc.scafDateAllMany": "Also change the {n} other rows on this project that start on {date}",
  "jc.scafDateAllUndatedOne": "Also set it on the 1 other row on this project with no start date",
  "jc.scafDateAllUndatedMany": "Also set it on the {n} other rows on this project with no start date",
  "jc.scafDateAllHint": "A row that left the site before the new date is left as it is.",
  "jc.scafDateInvalid": "Pick a date.",
  "jc.scafDateAfterEnd": "This row left the site on {date}, so it cannot have arrived after that. Use {date} itself if it was never on this project — that is zero days.",
  "jc.scafDateMissing": "This row is no longer on the project. Close this and look again.",
  "jc.scafDatePartial": "Only {n} of {of} rows were saved. Check that you are signed in as an admin, then try again.",
  "jc.scafDateOverlapOne": "{name} is already on this project from {from} to {to} in another row.\n\nStarting this row on {date} puts both rows on the same days, so those days are charged twice.\n\nIf these are extra pieces, press OK. If it is the same gear, press Cancel and pick a date on or after the day the other row ends.",
  "jc.scafDateOverlapMany": "{n} of these rows would start while another row of the same piece is still on this project — the first is {name}, already here from {from} to {to}.\n\nStarting them on {date} puts both rows on the same days, so those days are charged twice.\n\nIf these are extra pieces, press OK. If it is the same gear, press Cancel and pick a date on or after the day the other rows end.",
  "jc.scafOverlapTag": "same piece, overlapping dates",
  "jc.ratesTitle": "Labour Rates by Classification",
  "jc.ratesHint": "Loaded rate incl. burden — what one hour really costs you: wage plus payroll costs (EI, CPP, WCB, vacation, benefits). Used for project costing only.",
  "jc.noTrades": "No classifications yet — set each worker's trade on the Workers tab.",
  "jc.wageOnFile": "wage on file: {wage}",
  "jc.invoiceTitle": "Delivery Cost",
  "jc.invoiceAmount": "Supplier invoice — with PST, without GST",
  "jc.invoiceHint": "Type subtotal + PST: on a BC invoice that is the line right above GST. GST comes back to you as a credit, so it is not a project cost. This replaces the estimate for this delivery, and no tax is added on top — the invoice already carries it.",
  "jc.invoiceHintRecipe": "Type subtotal + PST: on a BC invoice that is the line right above GST. GST comes back to you as a credit, so it is not a project cost.",
  "jc.invoiceNote": "Note (optional)",
  "jc.invoiceClear": "Back to estimate",
  "jc.invoiceRecipeNote": "This project costs material from its recipe, so a supplier invoice typed here is kept for the record and is not counted.",
  "jc.invoiceRecipeNoteOther": "Items on this delivery that no recipe line names count at your price-book prices; the ones a recipe line names are costed by the recipe.",
  "jc.invoiceInvalid": "Enter the invoice amount (zero or more).",
  "jc.estimatedTotal": "Estimated total",
  "jc.invOrderValue": "This order at price-book prices — for the record",
  "jc.invCounted": "Counted on this project",
  "jc.invLineCounted": "counted",
  "jc.invLineRecipe": "costed by the recipe",
  "jc.invLineExcluded": "not a cost — set on Material by task",
  "jc.directTotal": "Direct total",
  "jc.ringAria": "{pct} percent of budget spent",
  "jc.ringAriaNoBudget": "{amt} spent, no budget set",
  "jc.heroOfBudget": "{spent} spent of {budget} budgeted",
  "jc.heroOfBudgetOh": "{spent} spent of {budget} budgeted direct · {budgetAll} incl. {pct}% overhead",
  "jc.heroEscalation": "{amt} escalation allowance",
  "jc.planCovers": "takeoff covers {n} of {m} lines",
  "jc.planCoversList": "The takeoff covers {n} of {m} lines that carry money. No takeoff yet: {list}. Until each has one, the gauges show the takeoff without judging the spend against it.",
  "jc.ringPlanned": "{budget} in the takeoff · partial takeoff",
  "jc.ringAriaPlanned": "{amt} spent, {budget} in the takeoff; the takeoff does not cover every line",
  "jc.paceOver": "Takeoff allows {allow} at {pct}% earned — {amt} over",
  "jc.paceUnder": "Takeoff allows {allow} at {pct}% earned — {amt} under",
  "jc.paceOverSoFar": "Takeoff allows {allow} so far — {amt} over",
  "jc.paceUnderSoFar": "Takeoff allows {allow} so far — {amt} under",
  "jc.taskPctComplete": "{pct}% complete",
  "jc.planOverheadRow": "Overhead — {pct}% of direct, calculated",
  "jc.planTotalOh": "Total incl. overhead",
  "jc.planEscalationRow": "Escalation allowance",
  "jc.planTotalEsc": "Total incl. escalation",
  "jc.overheadTypedNote": "{amt} of this budget is typed under a cost group named “{name}”. Overhead is calculated on its own — {pct}% of direct cost — and is never filed under a group, so that allowance counts as direct budget, gets overhead budgeted on top of it, and can never be used up. If it is the same money, clear those cells in the takeoff on the Contract tab.",
  "jc.plannedMargin": "Takeoff margin: {amt} ({pct}% of contract) — contract {contract} less budget {budget}",
  "jc.plannedMarginOh": "Takeoff margin: {amt} ({pct}% of contract) — contract {contract} less budget {budget} incl. {oh}% overhead",
  "jc.plannedMarginEsc": "Takeoff margin: {amt} ({pct}% of contract) — contract {contract} less budget {budget} incl. {esc} escalation",
  "jc.plannedMarginOhEsc": "Takeoff margin: {amt} ({pct}% of contract) — contract {contract} less budget {budget} incl. {oh}% overhead and {esc} escalation",
  "jc.plannedMarginTyped": "Takeoff margin: {amt} — the profit typed on this task's takeoff (no contract value)",
  "jc.plannedMarginPct": "Takeoff margin: {amt} — the {pct}% profit in this task's takeoff (no contract value)",
  "jc.finishedOn": "Finished {date}",
  "jc.finishedUnder": "Finished {date} — {amt} under budget",
  "jc.finishedOver": "Finished {date} — {amt} over budget",
  "jc.finishedShort": "earned {amt} less than its takeoff price",
  "jc.finishedBeyond": "earned {amt} more than its takeoff price",
  "jc.finishedAhead": "earns its full contract from that day",
  "jc.projectedProfit": "Projected profit",
  "jc.projPlanned": "Takeoff margin {amt}",
  "jc.projUnder": "+ {amt} under budget on {tasks}",
  "jc.projOver": "− {amt} over budget on {tasks}",
  "jc.projNotEarned": "− {amt} short of takeoff price",
  "jc.projEarnedBeyond": "+ {amt} beyond takeoff price",
  "jc.projNoMarginPlus": "+ {amt} from {tasks} with no takeoff margin",
  "jc.projNoMarginMinus": "− {amt} from {tasks} with no takeoff margin",
  "jc.projTaskOne": "1 finished task",
  "jc.projTaskMany": "{n} finished tasks",
  "jc.projOverrun": "− {amt} already over budget",
  "jc.projGeneralMinus": "− {amt} filed to no task",
  "jc.projGeneralPlus": "+ {amt} of credits filed to no task",
  "jc.projLeavesOut": "leaves out {list}",
  "jc.projOutGeneral": "{amt} filed to no task",
  "jc.projOutNoPlan": "{names} (no takeoff)",
  "jc.projOutNoMargin": "{names} (a takeoff, but no contract value or profit typed)",
  "jc.projCantOne": "Can't project yet — {what} ({amt}) has no takeoff. Add it →",
  "jc.projCantMany": "Can't project yet — {what} ({amt}) have no takeoff. Add them →",
  "jc.projWhatCoOne": "1 change order",
  "jc.projWhatCoMany": "{n} change orders",
  "jc.projWhatLineOne": "1 task",
  "jc.projWhatLineMany": "{n} tasks",
  "jc.heroNoBudget": "No budget set yet",
  "jc.whereItGoes": "Where the money goes",
  "jc.shareOfSpend": "{pct}% of this project",
  "jc.overhead": "Overhead",
  "jc.overheadFoot": "{pct}% of direct cost",
  "jc.overheadUnset": "Not set — add it on Rates & Defaults",
  "jc.orgRowMissing": "Your company's overhead and sales tax rates could not be read, so no figures are shown — they would be wrong without them.",
  "jc.loadOffline": "Could not reach the server, so no figures are shown. Check your connection and try again.",
  "jc.loadRetry": "Try again",
  "jc.overheadRow": "Off-site overhead",
  "jc.overheadCalc": "{pct}% of {base} direct cost",
  "jc.grandTotal": "Total",
  "jc.grandWithOverhead": "Total incl. overhead",
  "jc.inclSub": "incl. {amt} subcontract",
  "jc.subBadge": "sub",
  "jc.noSubRate": "no rate set",
  "jc.setSubRate": "click to set what this project pays for it",
  "jc.subAlsoHours": "also on timesheet",
  "jc.subAlsoHoursHint": "this sub foreman filed timesheet hours on this project — check the profile flag, the crew may be billing by hour and by unit",
  "jc.subAlsoHoursCrew": "{hours} h are logged to a crew member with this name and already charged under Labour — the same work may be paid twice",
  "jc.blocks": "blocks",
  "jc.bricks": "bricks",
  "jc.firestop": "LF firestop",
  "jc.subRatesBtn": "Sub rates",
  "jc.subRatesTitle": "Subcontract Rates",
  "jc.setupTitle": "Set up project costing",
  "jc.setupWhy": "Job Costs prices this project from these. Each one ticks itself once it is in, and this card goes away when all are.",
  "jc.setupCount": "{n} of {total} done",
  "jc.setupDoneSr": "done",
  "jc.setupOverhead": "Overhead % and sales tax (PST)",
  "jc.setupLoaded": "Loaded labour rate for each trade",
  "jc.setupItems": "Production items with a unit and a price",
  "jc.setupContract": "Contract lines for this project",
  "jc.setupSub": "Sub rates for the sub crews on this project",
  "jc.setupCatalogue": "Delivery catalogue prices",
  "jc.setupWhereRates": "Rates & Defaults",
  "jc.setupWhereContract": "Contract",
  "jc.setupWhereSub": "Sub rates",
  "jc.subRatesHint": "What you pay the subcontractor per unit installed, on this project — one rate for each production item. A sub crew files no timesheet, so this is how their work becomes cost. Leave an item blank if it does not apply.",
  "jc.subRatesEmpty": "This project has no production items yet. They appear here as soon as a contract line names one or a crew reports one.",
  "jc.subRateFallback": "No rate typed for this item — the {rate} category rate below is used.",
  "jc.subLegacyTitle": "Rates by category (earlier setup)",
  "jc.subLegacyHint": "Still used for any item of that kind that has no rate of its own above, and the only rate for a report that was filed without line items. These three price only block, brick and firestop items and reports in the older format; any other item needs its own rate above. Clear one to stop using it.",
  "jc.subPerBlock": "Per block",
  "jc.subPerBrick": "Per brick",
  "jc.subPerLf": "Per LF firestop",
  "jc.subRatesInvalid": "Rates must be zero or positive numbers.",
  "jc.subBaseHint": "Each rate below applies from the start of the project, up to its first dated change if it has one. To change what an item pays from a day on, without touching earlier work, add a change at the bottom.",
  "jc.subFiledWork": "Filed work: {parts}",
  "jc.subFiledWorkNoRate": "no rate on file",
  "jc.subChangeFrom": "{rate} from {date}",
  "jc.subChangeRemove": "Remove this change",
  "jc.subChangeRemoveAsk": "Remove this rate change? Work from that day goes back to the rate before it.",
  "jc.subChangeNotRemoved": "The change was not removed — reload the page and try again.",
  "jc.subChangeAdd": "Add change",
  "jc.subChangeAddHint": "From and including the day you pick, the item is paid the new rate. Work reported before that day keeps its rate. A day ahead is fine — it starts counting when it arrives.",
  "jc.subChangeItem": "Item",
  "jc.subChangeRate": "New rate",
  "jc.subChangeDate": "From and including",
  "jc.subChangeIncomplete": "Pick the day this rate starts.",
  "jc.rateSince": "(from {date})",
  "jc.warnTag": "check",
  "jc.warnTagInfo": "note",
  "jc.warnNoteOne": "1 thing to check above",
  "jc.warnNoteMany": "{n} things to check above",
  "jc.checkFix": "Fix",
  "jc.checkCorrect": "It's correct",
  "jc.checkCorrectTip": "Mark as checked. It comes back by itself if these numbers change.",
  "jc.checkMarkedToast": "Marked as checked. It comes back if these numbers change.",
  "jc.checkNotSaved": "Not saved: your account may not be allowed to do this. Refresh and try again.",
  "jc.checkUndo": "Undo",
  "jc.checkedOne": "1 checked warning",
  "jc.checkedMany": "{n} checked warnings",
  "jc.checkedBy": "Checked by {name} · {date}",
  "jc.checkedSomeone": "a former user",
  "jc.warnDeliveryNoPriceOne": "1 delivery has items with no price on file — those items cost $0 here. Price them on Rates & Defaults, or type the supplier invoice on the delivery.",
  "jc.warnDeliveryNoPriceMany": "{n} deliveries have items with no price on file — those items cost $0 here. Price them on Rates & Defaults, or type the supplier invoice on each delivery.",
  "jc.warnExtraAmbiguous": "{items}: your catalogue has more than one item with this name, at different prices, so these are not priced. Give the same-named items one price on Rates & Defaults, or open the delivery on the Deliveries tab and add the item again from the list.",
  "jc.warnNotDeliveredOne": "1 order needed by {since} is not set to Delivered, so its material ({amount} at price-book prices) is not counted. If it arrived, set it to Delivered on the Deliveries tab.",
  "jc.warnNotDeliveredMany": "{n} orders are past their needed-by date (the earliest {since}) and not set to Delivered, so their material ({amount} at price-book prices) is not counted. Set the ones that arrived to Delivered on the Deliveries tab.",
  "jc.warnNotDeliveredBareOne": "1 order needed by {since} is not set to Delivered, so its material is not counted. If it arrived, set it to Delivered on the Deliveries tab.",
  "jc.warnNotDeliveredBareMany": "{n} orders are past their needed-by date (the earliest {since}) and not set to Delivered, so their material is not counted. Set the ones that arrived to Delivered on the Deliveries tab.",
  "jc.warnUncostedOne": "{who} filed 1 production report as own crew ({when}: {items}), and this project has no timesheet hours that week — that work carries no labour cost. Add the hours on a timesheet, or add what you paid as a Labour cost dated in that week.",
  "jc.warnUncostedMany": "{who} filed {n} production reports as own crew ({when}: {items}), in weeks with no timesheet hours on this project — that work carries no labour cost. Add the hours on a timesheet, or add what you paid as a Labour cost dated in those weeks.",
  "jc.warnUncostedTypedOne": "{who} filed 1 production report as own crew ({when}: {items}), and this project has no timesheet hours that week. {amount} of Labour cost has been typed on this project since — check it covers that work.",
  "jc.warnUncostedTypedMany": "{who} filed {n} production reports as own crew ({when}: {items}), in weeks with no timesheet hours on this project. {amount} of Labour cost has been typed on this project since — check it covers that work.",
  "jc.warnSubNoRate": "{who} installed {items} ({when}) and this project has no subcontract rate for it — that work costs $0 here. Open Sub rates and type what you pay for it.",
  "jc.warnSubAlsoHours": "{who} is paid per unit as a subcontract crew and also has timesheet hours on this project — the same work may be counted twice.",
  "jc.warnSubFiledHours": "{who} is paid per unit as a subcontract crew and also filed a timesheet on this project — check the same work is not paid by the hour and by the unit.",
  "jc.warnSubQtyMismatchOne": "{who}: 1 production report ({when}) says {reported} on the report but {counted} in its items. Cost follows the items, and so does earned until its task is marked finished — check the signed report.",
  "jc.warnSubQtyMismatchMany": "{who}: {n} production reports ({when}) say {reported} on the reports but {counted} in their items. Cost follows the items, and so does earned until its task is marked finished — check the signed reports.",
  "jc.warnUnratedHours": "{hours} of {what} have no loaded rate — they cost $0 here. Set the rate on Rates & Defaults.",
  "jc.warnUnratedNoTrade": "{hours} belong to workers with no classification — they cost $0 here. Set each worker's trade on the Workers tab.",
  "jc.warnLongDayOne": "{who} has {hours} on {when} on this project — more than {limit} hours in one day. Check the timesheet.",
  "jc.warnLongDayMany": "{who} has {n} days over {limit} hours on this project ({when}, up to {hours} in one day). Check the timesheets.",
  "jc.warnEquipOverlap": "{what} is on this project twice with overlapping dates ({when}: {days} days, {amount}) — check it is not entered twice.",
  "jc.warnEquipOverlapDay": "{what} is on this project twice on {when} ({amount} for that day) — check it is not entered twice.",
  "jc.warnEquipOverlapGroup": "{what} is on this project {n} times with overlapping dates ({when}) — {amount} more than one of them would cost on the days they overlap. Check it is not entered more than once.",
  "jc.warnScaffoldTwoDoors": "Scaffold is on this project twice over: typed as a rental ({what}) and priced piece by piece from Equipment › Rental. Both are in this total — {amount} on the days they overlap ({when}), at the cheaper of the two. If it is the same gear it is being charged twice: end the typed rental, or take the pieces off this site.",
  "jc.warnScaffoldOverlapOne": "{what} is on this project in two rows whose dates overlap ({when}) — {amount} of it is charged twice if that is the same gear. Open either row to correct the day it arrived.",
  "jc.warnScaffoldOverlapMany": "{n} rented pieces are each on this project in two rows whose dates overlap ({when}) — {amount} is charged twice if that is the same gear. Open a row to correct the day it arrived.",
  "jc.warnScaffoldTwoDoorsBare": "Scaffold is on this project twice over: typed as a rental ({what}) and priced piece by piece from Equipment › Rental. Both count in this total. If it is the same gear it will be charged twice: end the typed rental, or take the pieces off this site.",
  "jc.warnRentalIdle": "{what} has been on rent since {from} with no return date, and nothing has been reported on this project since {date} — it has added {amount} in the {days} days since.",
  "jc.warnRentalIdleMany": "{n} rentals have no return date ({what}), and nothing has been reported on this project since {date} — they have added {amount} in the {days} days since.",
  "jc.warnRentalIdleNeverMany": "{n} rentals have no return date ({what}), and nothing has been reported on this project since they arrived — {amount} so far.",
  "jc.warnRentalIdleNever": "{what} has been on rent since {from} with no return date, and nothing has been reported on this project since it arrived — {amount} over {days} days.",
  "jc.warnRentalNoSiteCode": "This project has no site code, so rented equipment in Equipment › Rental cannot be matched to it — any rented equipment costs $0 here. Set the site code on All Projects.",
  "jc.warnRentalNoPriceOne": "1 rented piece has no price on file — it costs $0 here. Set its daily rate in Equipment › Rental.",
  "jc.warnRentalNoPriceNamed": "{what} is on rent with no price on file — it costs $0 here. Set its daily rate in Equipment › Rental.",
  "jc.warnRentalNoPriceMany": "{n} rented pieces have no price on file — they cost $0 here. Set their daily rates in Equipment › Rental.",
  "jc.warnRentalNoDateOne": "1 rented piece has no start date on file — it costs $0 here. Open its row under Equipment on Job Costs to set the date.",
  "jc.warnRentalNoDateNamed": "{what} is on rent with no start date on file — it costs $0 here. Open its row under Equipment on Job Costs to set the date.",
  "jc.warnRentalNoDateMany": "{n} rented pieces have no start date on file — they cost $0 here. Open their rows under Equipment on Job Costs to set the dates.",
  "jc.warnProdEarlyOne": "{who} filed 1 production report dated {when}, after the day it was filed — it may belong to an earlier week.",
  "jc.warnProdEarlyMany": "{who} filed {n} production reports dated {when}, after the day they were filed — they may belong to an earlier week.",
  "jc.warnProdSameDayOne": "{who} reported the same {items} twice on {when} — check it was not entered twice.",
  "jc.warnProdSameDayMany": "{who} reported the same quantities twice on {n} days ({when}: {items} in all) — check none was entered twice.",
  "jc.warnProdOutlier": "{who} reported {items} on {when} — more than any day your company had on file for this item before that week (max {max}) and over {factor} times a usual day ({median}). Check the unit was read right.",
  "jc.warnStalePctOne": "{what} ({amount}) is still at 0%, and work has been reported on this project since {since} — earned may be understated.",
  "jc.warnStalePctMany": "{n} fixed-amount contract lines ({amount}) are still at 0%, and work has been reported on this project since {since} — earned may be understated.",
  "rt.payTitle": "Pay Rates (by trade)",
  "rt.payHint": "Wage = what you pay the worker per hour. Loaded rate = what one hour really costs you (wage + EI, CPP, WCB, vacation, benefits) — Job Costs uses the loaded rate.",
  "rt.delivTitle": "Delivery Material Prices",
  "rt.delivHint": "Price per unit the foreman orders (pallet / bundle / roll), exactly as your supplier quotes it — before any tax. Job Costs adds your sales tax rate on top when it estimates a delivery, so do not build it into the price here. A delivery where you typed the supplier invoice ignores these prices entirely. Items are managed on the Deliveries tab.",
  "rt.delivShort": "The price per unit your foremen order, before any tax — as your supplier quotes it.",
  "rt.revTitle": "Production Items & Billing Rates",
  "rt.revHint": "This is the list your foremen pick from on the Production Report, plus what you bill per unit of each. Unit is whatever your trade counts in — blocks, SF, LF, yd³, tonnes. Delete an item nobody has reported yet; hide one your crews already used — hiding takes it off the form and keeps every report already filed.",
  "rt.revShort": "The items your foremen pick on the Production Report, and what you bill per unit.",
  "rt.mtItem": "Item",
  "rt.mtUnit": "Unit",
  "rt.mtRate": "Default price (projects without their own)",
  "rt.mtRateAria": "{name} default price, for projects without their own",
  "rt.mtUsedByOne": "used by 1 project",
  "rt.mtUsedByMany": "used by {n} projects",
  "rt.mtRateEffectTitle": "Change the default price of \"{name}\"?",
  "rt.mtRateEffectLine": "Earned on {name}: {from} → {to}",
  "rt.mtRateEffectContract": "Contract on {name}: {from} → {to}",
  "rt.mtRateEffectUnread": "The projects that use this price could not be read just now, so the effect on them cannot be shown.",
  "rt.mtRateEffectUnknown": "This price is used by {names}. Their contract lines and production could not be read just now, so the effect cannot be shown.",
  "rt.mtUnitLocked": "locked",
  "rt.mtUnitLockedOne": "1 report · locked",
  "rt.mtUnitLockedMany": "{n} reports · locked",
  "rt.mtUnitLockedHint": "Reports your crews already filed are counted in this unit, so it cannot change.",
  "rt.mtUnitLockedNote": "Need a different unit? Add a new item. A unit locks once a crew has reported the item, so the reports already filed keep reading right.",
  "rt.mtEmpty": "No production items yet. Add what your crews report building — the Production Report reads this list.",
  "rt.mtNewName": "New item name",
  "rt.mtNewUnit": "Unit",
  "rt.mtHide": "Hide from the Production Report",
  "rt.mtRestore": "Put back on the Production Report",
  "rt.mtDelete": "Delete for good",
  "rt.mtDelTitle": "Delete \"{name}\" for good?",
  "rt.mtDelBody": "No crew has ever reported this item, so no report changes. It leaves the Production Report and this list for good.",
  "rt.mtDelRates": "Any per-project billing rate or subcontract rate you set for it goes with it.",
  "rt.mtDelPack": "It came with the {pack} trade pack, so adding that pack again brings it back.",
  "rt.mtDelGo": "Delete for good",
  "rt.mtDelUsedTitle": "\"{name}\" is on reports your crews already filed",
  "rt.mtDelUsedBody": "Your crews have reported it {times}, so deleting it would erase those numbers from the reports and from Job Costs. That is why it cannot be deleted.",
  "rt.mtDelUsedHide": "Hiding it takes it off the Production Report right away, and every report already filed keeps what it says.",
  "rt.mtDelUsedAlready": "It is already hidden, so nobody can pick it on the Production Report.",
  "rt.mtDelTimesOne": "once",
  "rt.mtDelTimesN": "{n} times",
  "rt.mtDelHideInstead": "Hide it instead",
  "rt.mtDelGotIt": "Got it",
  "rt.mtDelRace": "A crew reported \"{name}\" just now, so it can no longer be deleted — hide it instead.",
  "rt.mtHidden": "{n} hidden",
  "rt.mtPackHidden": "{n} more items came from trade packs you removed. Your crews cannot report them, so there is nothing to bill — they come back if you add the pack again.",
  "rt.mtNameRequired": "Give the item a name.",
  "rt.mtBadRate": "Billing rate must be zero or a positive number.",
  "rt.mtDuplicate": "You already have an item called \"{name}\".",
  "rt.ohTitle": "Overhead & Sales Tax",
  "rt.pstOn": "sales tax you cannot claim back, on estimated material",
  "rt.ohSaved": "Saved. Overhead is now {pct}% of direct cost on every project.",
  "rt.pstSaved": "Saved. Sales tax is now {pct}% on estimated material.",
  "rt.ohInvalid": "Not saved. Type a percentage between 0 and 100 — the field is back to the rate your projects are using.",
  "rt.ohNotSaved": "Not saved: {msg}. The field is back to the rate your projects are using.",
  "rt.ohRefused": "Not saved — the change was not accepted. The field is back to the rate your projects are using.",
  "rt.ohNoRow": "Your company's overhead and sales tax rates could not be read. Reload the page to try again.",
  "rt.pstHint": "Sales tax (PST in BC) is the tax you cannot claim back, so it is a real cost — unlike GST, which returns as an input tax credit. It applies only to what is priced from the price book, since those prices are typed before tax. A delivery where you typed the supplier invoice already includes it, so does a recipe component you typed yourself, and labour never carries it.",
  "rt.pstShort": "Sales tax you can’t claim back (PST in BC) is added to price-book prices only.",
  "jc.pstRow": "Sales tax on estimated material",
  "jc.pickedUpAt": "Picked up at",
  "jc.pstRowSub": "{pct}% of {base} — invoiced deliveries already include it",
  "jc.marginLabel": "Margin",
  "jc.marginNothingEarned": "nothing earned yet",
  "jc.marginPctOfEarned": "{pct}% of earned",
  "jc.marginUnpricedOne": "1 line has no price on file",
  "jc.marginUnpricedMany": "{n} lines have no price on file",
  "jc.moveHint": "File this cost under a different group",
  "jc.moveHintMoved": "Moved — file this cost under a different group",
  "jc.moveTitle": "File this cost under",
  "jc.manageTopics": "Manage groups",
  "jc.taskSectTitle": "Task",
  "jc.taskGeneral": "General (unassigned)",
  "jc.taskSplitBtn": "Assign items individually…",
  "jc.taskSplitTitle": "Assign items to tasks",
  "jc.taskSplitInvoiced": "This order was priced by its supplier invoice — one amount, so it files as a whole.",
  "jc.taskSplitUnavailable": "These items can no longer be assigned individually — assign the whole order instead.",
  "jc.taskSplitInherit": "Same as whole order",
  "jc.taskSplitItemRule": "Same as this item on Material by task",
  "jc.taskSplitItemDefault": "Item's default ({task})",
  "jc.taskColLabel": "Task",
  "jc.chipNone": "No task",
  "jc.chipPartial": "Partly filed",
  "jc.chipManyTasks": "{n} tasks",
  "jc.chipHint": "Task: {task}",
  "jc.unfiledOne": "{amount} on 1 line has no task yet",
  "jc.unfiledN": "{amount} across {n} lines has no task yet",
  "jc.unfiledShowOnly": "Show only these",
  "jc.unfiledShowAll": "Show everything",
  "jc.unfiledFileThem": "File them…",
  "jc.unfiledAllDone": "Every cost on this project is filed under a task.",
  "jc.unfiledTotal": "Total with no task",
  "jc.fileAllTitle": "Costs with no task",
  "jc.fileAllHead": "{n} lines · {amount} still to file",
  "jc.fileAllHeadOne": "1 line · {amount} still to file",
  "jc.fileAllHint": "Pick the contract line each cost belongs to. Anything you already assigned by hand — a single item on an order, or hours a crew filed against a task — keeps what it has.",
  "jc.fileAllSetAll": "Set every line to",
  "jc.fileAllLeave": "Leave for now",
  "jc.fileAllSave": "Save",
  "jc.fileAllSaveN": "Save {n}",
  "jc.fileAllNothing": "Nothing left to file — every cost on this project is under a task.",
  "jc.fileAllDelivery": "Delivery",
  "jc.fileAllReplacesSplit": "replaces its current split",
  "jc.fileAllKeepsItemRule": "items with a task on Material by task keep it",
  "jc.moveSplitNote": "This cost is split across tasks — picking one task replaces the split.",
  "jc.moveTaxNote": "Sales tax follows the material it was charged on. A task picked here only takes the tax on material that has no task of its own.",
  "jc.moveItemRuleNote": "Items on this order that have a task on Material by task keep it: a task picked here files only the rest of this order. To file one of them differently on this order, use “Assign items individually…”.",
  "jc.csplitTitle": "Split this cost across tasks",
  "jc.csplitOpenBtn": "Split by date or share…",
  "jc.csplitFrom": "From",
  "jc.csplitTo": "To",
  "jc.csplitShare": "Share",
  "jc.csplitAdd": "Add a task",
  "jc.csplitRemove": "Remove this row",
  "jc.csplitRest": "No task (the remainder)",
  "jc.csplitHintDated": "Money follows the dates. Leave From blank for the start, To blank while it runs — an open rental keeps accruing into its last window. The To date is the handover day: it counts for the next task. Two tasks over the same days split by share.",
  "jc.csplitHintUndated": "This cost has no period — pick tasks and shares; whatever is left stays under No task.",
  "jc.csplitOrderPart": "{kept} of this order ({whole}) is filed by item — a task picked for the item on Material by task, or for that line under “Assign items individually…” — and is not split here.",
  "jc.csplitOver100": "These shares add to more than 100%.",
  "jc.csplitNot100": "These shares must add to 100%.",
  "jc.csplitOver100At": "More than 100% of the cost is claimed on {date}.",
  "jc.pstRowSubRecipe": "{pct}% of {base} — what the recipe priced from the price book",
  "jc.pstRowSubRecipeOther": "{pct}% of {base} — what the recipe and the delivered items not in a recipe priced from the price book",
  "jc.recipeExtraSub": "Recipe components filed under this group · {qty} {unit} installed",
  "jc.entryVoidNote": "not counted — this project costs material from its recipe",
  "jc.otherCounted": "counted: {items} — in no recipe line",
  "jc.otherCoveredOne": "1 item on this order is costed by the recipe, not counted here",
  "jc.otherCoveredMany": "{n} items on this order are costed by the recipe, not counted here",
  "jc.otherNoPriceOne": "{items} — in no recipe line, no price on file: it costs $0 until priced on Rates & Defaults",
  "jc.otherNoPriceMany": "{items} — in no recipe line, no price on file: they cost $0 until priced on Rates & Defaults",
  "jc.otherAmbiguous": "{items} — {why}, so not priced",
  "jc.otherNotInCatalogueOne": "{items} — not in your catalogue, so it is not priced and not counted",
  "jc.otherNotInCatalogueMany": "{items} — not in your catalogue, so they are not priced and not counted",
  "jc.otherFreeText": "typed as free text, so it has no price-book price — not counted on a recipe project",
  "jc.otherPending": "not counted until it is set to Delivered on the Deliveries tab — then {items} will count ({amt} at price-book prices): in no recipe line",
  "jc.otherPendingBare": "not set to Delivered on the Deliveries tab — {items}: in no recipe line, no price on file",
  "jc.otherInvoiceNote": "the supplier invoice is not used on a recipe project — these items count at price-book prices",
  "jc.otherNone": "not counted — this project costs material from its recipe",
  "jc.otherExcluded": "{items} — set to “Not a cost” on Material by task: not counted",
  "jc.labourSubTimesheet": "by timesheet",
  "jc.labourSubRest": "No activity logged — follows this row → {dest}",
  "jc.labourSubHours": "{hours}",
  "jc.labourSubSick": "incl. {hours} paid sick",
  "jc.labourSubSplit": "split across tasks",
  "jc.taskGeneralShort": "General",
  "jc.topicsBtn": "Groups",
  "jc.topicsTitle": "Cost Groups",
  "jc.topicsHint": "Material, Labour, Equipment, Trucking, Safety and Other are always here — rename or recode any of them for your company; they can't be deleted. Add your own for anything your trade files separately — then use the arrow on any line of the statement to move a cost into it. Moving a cost changes the heading it reads under, never the amount.",
  "jc.topicsShort": "The six standard groups are always here — add your own and move costs into them.",
  "jc.topicAdd": "Add",
  "jc.topicNameAria": "Group name",
  "jc.topicDelete": "Delete this group",
  "jc.topicNameNeeded": "Type a name for the group.",
  "jc.topicDup": "You already have a group with that name.",
  "jc.topicNameReserved": "“{name}” is the name of the calculated overhead line, which is never filed under a group. Pick another name for this group.",
  "jc.topicDeleteTitle": "Delete {name}?",
  "jc.topicDeleteCounts": "Filed under it: {list}.",
  "jc.topicDeleteMovedOne": "1 moved cost line",
  "jc.topicDeleteMoved": "{n} moved cost lines",
  "jc.topicDeleteTypedOne": "1 typed cost",
  "jc.topicDeleteTyped": "{n} typed costs",
  "jc.topicDeleteJoin": " and ",
  "jc.topicDeleteSafe": "Nothing is lost: every one of them goes back to the group it came from, and no total changes.",
  "jc.topicDeleteEmpty": "Nothing is filed under it.",
  "jc.topicDeleteGo": "Delete group",
  "jc.groupCodeLabel": "Code",
  "jc.groupResetBtn": "Reset name & code",
  "jc.groupBuiltInHint": "Built-in group — rename it for your company; it can't be deleted.",
  "jc.groupCodeInvalid": "Code must be 2-5 letters or numbers.",
  "jc.noneInTopic": "Nothing filed under this group yet — use the arrow on any line above to move a cost into it.",
  "jc.railContract": "Contract",
  "jc.railEarned": "Earned",
  "jc.railLines": "{n} lines",
  "jc.railLineOne": "1 line",
  "jc.railOfContract": "{pct}% of contract",
  "jc.openEarnedNote": "+ {amt} earned on lines with no cap",
  "jcx.title": "Recent changes on this project",
  "jcx.note": "Prices, recipes, contract and costs — newest first",
  "jcx.empty": "No change to a price, recipe, contract line or cost has been recorded on this project yet.",
  "jcx.loadFailed": "Could not load the changes: {msg}",
  "jcx.system": "System",
  "jcx.unknownPerson": "Unknown user",
  "jcx.added": "added",
  "jcx.removed": "removed",
  "jcx.thisProject": "This project",
  "jcx.cost": "Cost",
  "jcx.rental": "Rental",
  "jcx.fAmount": "amount",
  "jcx.fContract": "contract amount",
  "jcx.fQty": "contract quantity",
  "jcx.fPaidBy": "paid by",
  "jcx.fSellPrice": "sell price",
  "jcx.fSubPrice": "sub price",
  "jcx.fFrom": "from",
  "jcx.fDate": "date",
  "jcx.fGroup": "group",
  "jcx.fMonthly": "monthly rate",
  "jcx.fStart": "start",
  "jcx.fEnd": "end",
  "jcx.fPieces": "pieces",
  "jcx.fSubCrew": "sub crew rate",
  "jc.railGroups": "{n} groups",
  "jc.railGroupOne": "1 group",
  "jc.railDirectPlusOh": "direct + overhead",
  "jc.unitColItem": "Item",
  "jc.unitColInstalled": "Installed",
  "jc.unitColCost": "Cost / unit",
  "jc.unitColEarns": "Earns / unit",
  "jc.unitColMargin": "Profit / unit",
  "jc.byTaskColTask": "Task",
  "jc.byTaskCost": "Cost",
  "jc.byTaskTotal": "Total, every task",
  "jc.colDate": "Date",
  "jc.colWhat": "What it was",
  "jc.colTask": "Task",
  "jc.colAmount": "Amount",
  "jc.grpN": "{n} shown",
  "jc.grpUnfiledN": "{n} unfiled shown",
  "jc.statementNote": "Every entry, where it files, and which task it belongs to",
  "jc.statementTitleUnfiled": "Statement — unfiled entries only",
  "jc.unfiledWhy": "It sits in General, so each task's profit reads higher than it really is.",
  "jc.chipFixed": "Shared by all tasks",
  "jc.chipFixedHint": "Calculated — spread over every task in proportion to its direct cost",
  "jc.rowDelivery": "Delivery",
  "jc.rowPickup": "Pickup",
  "jc.rowPickupAt": "Pickup · {supplier}",
  "jc.poShort": "PO",
  "jc.byTaskTitle": "By task",
  "jc.byTaskHint": "Each task's cost includes overhead ({pct}% of its direct cost), so the total row is the project's total cost and profit. Assign lines with the arrow on any statement row.",
  "jc.byTaskHintNoOverhead": "Direct cost per task — no overhead set. Assign lines with the arrow on any statement row.",
  "jc.byTaskHintCostOnly": "Each task's cost includes overhead ({pct}% of its direct cost), so the total row is the project's total cost. No contract value on file yet, so there is no profit figure. Assign lines with the arrow on any statement row.",
  "jc.byTaskHintNoOverheadCostOnly": "Direct cost per task — no overhead set. No contract value on file yet, so there is no profit figure. Assign lines with the arrow on any statement row.",
  "jc.byTaskGeneral": "General — not assigned to a task",
  "jc.byTaskInclOverhead": "incl. {pct}% overhead",
  "jc.byTaskBudget": "Budget",
  "jc.byTaskActual": "Actual",
  "jc.byTaskDelta": "Δ",
  "jc.byTaskSubtotal": "Task total",
  "jc.byTaskEarned": "Earned so far",
  "jc.byTaskNoLines": "Add contract lines on the Contract tab to see cost by task.",
  "jc.spentTitle": "Spent so far",
  "jc.spentFoot": "Before overhead · up to {date}",
  "jc.spentFootNoOh": "Up to {date}",
  "jc.spentOverhead": "+ {amount} overhead ({pct}%)",
  "jc.ovTitle": "Tasks over the takeoff",
  "jc.ovNone": "No task is over its takeoff.",
  "jc.ovBuilt": "{pct}% built",
  "jc.ovFinished": "Finished",
  "jc.ovNoProduction": "No production logged yet",
  "jc.ovNoQty": "No takeoff quantity",
  "jc.ovItem": "{group} {amount}",
  "jc.ovOver": "{list}\u00a0over",
  "jc.ovNotInTakeoff": "{list}\u00a0not in the takeoff",
  "jc.ovIncl": "incl. {list}",
  "jc.ovOnTrackOne": "1 task on track",
  "jc.ovOnTrackMany": "{n} tasks on track",
  "jc.ovNoTakeoffOne": "1 task has no takeoff",
  "jc.ovNoTakeoffMany": "{n} tasks have no takeoff",
  "jc.ovNoTakeoffAll": "{n} tasks have no takeoff yet. Add it on the Contract tab →",
  "jc.ovNoTakeoffAllOne": "1 task has no takeoff yet. Add it on the Contract tab →",
  "jc.ovNoTakeoffLink": "Add the takeoff on the Contract tab →",
  "jc.ovNoTakeoffRow": "No takeoff",
  "jc.ovSpent": "{amount} spent",
  "jc.ovWithin": "Within the takeoff",
  "jc.ovNoTasks": "Add your tasks and their takeoff on the Contract tab to see which task goes over →",
  "jc.ovNoQtyHint": "Add the takeoff quantity to {task} on the Contract tab to compare against what is built →",
  "jc.ovHours": "{h} hours ({amount}) had no task marked on the timesheet. The app put them in {task}.",
  "jc.ovHoursOne": "1 hour ({amount}) had no task marked on the timesheet. The app put it in {task}.",
  "jc.ovMoveThem": "Move them →",
  "jc.ovMoveIt": "Move it →",
  "jc.checksOne": "1 thing to check",
  "jc.checksMany": "{n} things to check",
  "jc.checksNoteOne": "1 note",
  "jc.checksNoteMany": "{n} notes",
  "jc.sectCosts": "All costs ({n})",
  "jc.sectMore": "More numbers",
  "jc.tdBack": "‹ Back",
  "jc.tdGroup": "Group",
  "jc.tdSpent": "Spent",
  "jc.tdAllows": "Takeoff allows",
  "jc.tdResult": "Result",
  "jc.tdOver": "{amount} over",
  "jc.tdUnder": "{amount} under",
  "jc.tdNotInTakeoff": "Not in the takeoff",
  "jc.tdBuiltQty": "{pct}% built · {installed} of {qty} {unit}",
  "jc.tdNoteBuilt": "{groups}: the takeoff for the {pct}% that is built.",
  "jc.tdNoteWholeOne": "{groups}: the whole takeoff, because it comes before the work is built.",
  "jc.tdNoteWholeMany": "{groups}: the whole takeoff, because they come before the work is built.",
  "jc.tdNoteFinished": "Finished: every group against its whole takeoff.",
  "jc.tdNoteNoProduction": "No production logged yet: every group against its whole takeoff.",
  "jc.tdNoteNoQty": "No takeoff quantity: every group against its whole takeoff.",
  "jc.tdNoteOverhead": "All amounts before the {pct}% overhead.",
  "jc.tdNoTakeoff": "This task has no takeoff yet.",
  "jc.tdEscalation": "The takeoff also carries {amount} for escalation, outside the groups.",
  "jc.tdCosts": "Costs in this task ({n})",
  "jc.tdCostsTotal": "Total, before overhead",
  "jc.tdOf": "of {amount}",
  "jc.tdWithOh": "With overhead",
  "rt.ohHint": "Everything off the jobsite that never arrives as an invoice — office, yard, accountant, project managers, salaries. Job Costs adds this percentage on top of each project's direct cost (every cost group on the project). You work out the percentage; the app just applies it.",
  "rt.ohShort": "Overhead covers office costs that never arrive as an invoice — Job Costs adds it on top.",
  "rt.ohOnTop": "on top of each project's direct cost",
  "rt.dpNoPrice": "no price",
  "rt.dpEmpty": "No delivery materials in the catalogue yet — add them on the Deliveries tab.",
  "rt.dpSearch": "Search items…",
  "rt.dpNoMatch": "No items match “{q}”.",
  "rt.dpNoPack": "General",
  "rt.dpPriced": "{priced} of {total} priced",
  "rt.dpNeedsTitle": "{n} ordered without a price",
  "rt.dpNeedsHint": "Your crew has already ordered these, so they land in Job Costs with no cost against them. Everything below can stay blank until you actually order it.",
  "rt.dpHidden": "{n} more items belong to trade packs you removed. Your crew cannot order them, so there is nothing to price — they come back if you add the pack again.",
  "rt.pkHint": "Pack is how many usable pieces come in one unit you order, and what you call one of them. Leave it blank whenever you order and use the same thing — most items. Cost Recipes then lets you say how far ONE piece goes, instead of working out a fraction of the whole unit yourself. Filling this in costs your projects nothing: any recipe already written is restated into the new piece, so the money holds still. Later changing a pack you had already filled in does re-price them — because that time the supplier really changed.",
  "rt.pkShort": "Pack: how many usable pieces come in one unit you order. Most items leave it blank.",
  "rt.pkPer": "per {unit}",
  "rt.pkPiece": "piece",
  "rt.pkUnitPh": "pieces",
  "rt.pkEach": "= {amt} per {unit}",
  "rt.pkCountAria": "how many pieces come in one {unit} — leave blank if you use it whole",
  "rt.pkUnitAria": "what one of those pieces is called",
  "jv.addLineBtn": "Add line",
  "jv.noProjects": "Add a project first — a contract belongs to a project.",
  "jv.archivedSuffix": " (archived)",
  "jv.emptyTitle": "No contract lines yet",
  "jv.emptyHint": "Add a line for each part of the project you bill for. A line either carries a fixed amount you mark complete as you go, or points at a production item and earns itself from what your crew reports.",
  "jv.kpiUnpriced": "Unpriced lines",
  "jv.unpricedFoot": "each earns nothing until it has a rate",
  "jv.remainingFoot": "at today's rates and quantities",
  "jv.unpricedBannerOne": "{name} has no rate",
  "jv.unpricedBannerMany": "{n} lines have no rate",
  "jv.unpricedBannerHolds": "They hold {amt} of contract and earn $0 until a rate is set.",
  "jv.setRateBtn": "Set rate",
  "jv.linesTitle": "Contract lines",
  "jv.totalOne": "Total · 1 line",
  "jv.totalN": "Total · {n} lines",
  "jv.kpiContract": "Contract",
  "jv.kpiEarned": "Earned",
  "jv.kpiLeftToEarn": "Left to earn",
  "jv.contractSplit": "base {base} + extras {extras}",
  "jv.pctOfContract": "{pct} of the contract",
  "jv.earnedOpenNote": "+ {amt} earned on lines with no cap — not part of the contract total",
  "jv.totalOpenNote": "{amt} on lines with no cap — not in the %",
  "jv.unpricedWarnHint": "Set a sell price on the line itself — a line with no price on file keeps counting as nothing.",
  "jv.badgeCo": "CO",
  "jv.badgeEwo": "EWO",
  "jv.qtyProgressGoTitle": "Moved by the Production Report, not typed here — open the reports behind this figure",
  "jv.rateLabel": "Sell price for this project ($/{unit})",
  "jv.rateHint": "Pre-fills with this project's sell price for the item — or, when the project has none yet, the item's rate on Rates & Defaults. Leave it blank to price the line later.",
  "jv.rateEditAria": "Edit {name} sell price, this project only",
  "jv.effectEarned": "Earned on {name}: {from} → {to}.",
  "jv.effectContract": "Contract: {from} → {to}.",
  "jv.effectSave": "Save?",
  "jv.errRateInvalid": "Enter a sell price of 0 or more, or leave it blank.",
  "jv.methodFixed": "Fixed amount",
  "jv.methodProdItemFallback": "Production item",
  "jv.noPriceOnFile": "no price on file",
  "jv.deleteLineTitle": "Delete line",
  "jv.lockedCoTitle": "Created from an approved change order — un-approve it first, then this line can be removed here.",
  "jv.lockedEwoTitle": "Created from an approved extra work order — un-approve it first, then this line can be removed here.",
  "jv.lockedDeleteAlert": "This line comes from an approved change order or extra work order. Un-approve the source first, then delete the line here.",
  "jv.colLine": "Line",
  "jv.nameAria": "Contract line name",
  "jv.nameTitle": "Line name — renaming it updates Job Costs, the P&L and your crew’s task list",
  "jv.renamedToast": "Line renamed — Job Costs and the P&L follow it",
  "jv.colEarnsBy": "Paid by",
  "jv.colProgress": "Progress",
  "jv.colContract": "Contract",
  "jv.colEarned": "Earned",
  "jv.colPercent": "% earned",
  "jv.openLine": "No cap",
  "jv.openLineHint": "No agreed cap — earns every unit installed at this price.",
  "jv.saveError": "Could not save: {msg}",
  "jv.deleteError": "Could not delete: {msg}",
  "jv.deleteConfirm": "Delete \"{name}\" from the contract?",
  "jv.thisLine": "this line",
  "jv.asOfBtn": "Set % for a past date",
  "jv.asOfBtnTitle": "File this percent under the day it was reached, and see the dates already on file",
  "jv.asOfTitle": "Percent complete, as of a date",
  "jv.asOfPctLabel": "Percent complete",
  "jv.asOfDateLabel": "As of",
  "jv.asOfHint": "The percent counts from this date on, so a period view shows the revenue in the month it was earned. A date already on file takes the new percent. To move an entry to another day, save the percent under the right day, then remove the entry on the wrong day from the list below.",
  "jv.asOfHeldNote": "An entry dated {later} comes after this date, so the line will still read {current}%. Only the periods before {next} change.",
  "jv.asOfRemove": "Remove",
  "jv.asOfRemoveAria": "Remove the entry: {date}",
  "jv.asOfRemoveConfirm": "Remove this entry — {date}, {pct}%?\n\nThe line will then read {current}%.",
  "jv.asOfRemoveNone": "the entry was not removed — check that you are signed in as an admin",
  "jv.asOfHistTitle": "On file",
  "jv.asOfHistNone": "No dated entries yet.",
  "jv.asOfHistErr": "Could not read the dates on file: {msg}",
  "jv.asOfHistCurrent": "current",
  "jv.asOfBefore": "Before progress was dated",
  "jv.asOfErrPct": "Enter a percent from 0 to 100.",
  "jv.asOfErrDate": "Pick a date.",
  "jv.asOfErrFuture": "The date cannot be after today — a line's percent is what it has reached so far.",
  "jv.creditHint": "Credit — counted in full. Set it to 0% if it removes units a quantity line will simply never install: those already lower Earned.",
  "jv.creditHintPart": "Credit — {pct}% counted. Set it to 100% if it is a price reduction, or if the work it removes was already earned.",
  "jv.creditHintZero": "Credit — not counted: the missing units already lower Earned. Set it to 100% if it is a price reduction, or if the work it removes was already earned.",
  "jv.creditHintFinished": "Credit — {pct}% counted. A task marked finished earns its full contract, so if this credit removes units or work from one, count it in full (100%).",
  "jv.addTitle": "Add a contract line",
  "jv.descLabel": "Description",
  "jv.descPlaceholder": "What this line covers",
  "jv.methodLabel": "How it earns",
  "jv.methodPercentOpt": "A fixed amount I mark complete",
  "jv.methodQtyOpt": "A production item — earns itself from the field",
  "jv.methodQtyOptNone": " (none set up yet)",
  "jv.noTypesHint": "No production items are set up for this organization yet — add a trade pack, or add a material type on Rates & Defaults, then come back to point a line at it.",
  "jv.amountLabel": "Contract amount",
  "jv.amountEditTitle": "Edit the contract amount",
  "jv.amountModalTitle": "Edit the contract amount",
  "jv.amountModalQtyHint": "Type the total and the sell price follows. Change the quantity and whichever of the two you typed last — total or sell price — stays; the other follows.",
  "jv.amountModalKeepsRate": "Sell price kept — the total follows the quantity.",
  "jv.amountModalKeepsAmount": "Total kept — the sell price follows the quantity.",
  "jv.amountModalInstalled": "{qty} installed so far on this line.",
  "jv.amountModalBelowInstalled": "{qty} already installed would stop earning ({amt}).",
  "jv.amountModalSharedRate": "Other lines on this project are also priced from {unit} — a new sell price changes them too.",
  "jv.errAmountQty": "Enter a quantity greater than 0.",
  "jv.amountSavedToast": "Contract amount saved",
  "jv.amountHalfSaved": "The sell price was saved, but the quantity was not: {msg}. Press Save to try again.",
  "jv.prodItemLabel": "Production item",
  "jv.qtyLabel": "Estimated quantity",
  "jv.qtyPlaceholder": "Blank = no cap",
  "jv.qtyHint": "The quantity installed comes from your crew's Production Reports — nothing to type twice there.",
  "jv.qtyOpenHint": "Leave this blank for a line with no cap: it earns every unit installed at this price, with no agreed total.",
  "jv.qtyOpenLiveNote": "This line will have no cap — it earns every unit your crew installs at this price.",
  "jv.errDescRequired": "Give the line a description.",
  "jv.errAmountRequired": "Enter the contract amount.",
  "jv.errNoTypes": "No production items available — add a trade pack or a material type on Rates & Defaults first.",
  "jv.errQtyInvalid": "Enter a quantity of 0 or more, or leave it blank for no cap.",
  "jv.errQtyOrRateRequired": "Enter a quantity, or a sell price for a line with no cap.",
  "jv.lineAmountHint": "Or type the total you agreed with the GC — the sell price above updates to match.",
  "jv.errAmountInvalid": "Enter a contract amount of 0 or more, or leave it blank.",
  "jv.editByTotalBtn": "Enter total $ instead",
  "jv.editByTotalTitle": "Correct this line's price using the total contract amount instead of the unit rate",
  "jv.editRateTitle": "Edit this line's price",
  "jv.editRateOnlyTitle": "Edit this line's price — it has no cap, so no total to edit by",
  "jv.rateModalHint": "Based on {qty} {unit} on this line. Change either number and the other updates to match.",
  "jv.rateRoundedHint": "Shown rounded to 2 decimals — the exact price is kept underneath so the total above stays exactly right.",
  "jv.planBtn": "Takeoff",
  "jv.planBudgetCol": "Takeoff (cost)",
  "jv.planDirectRow": "Direct total",
  "jv.planCostRow": "Cost incl. overhead",
  "jv.planProfitRow": "Profit",
  "jv.planProfitHint": "The profit added on top of the cost — a markup, never a cost: overhead is not charged on it.",
  "jv.planProfitPctAria": "Profit as a percent of cost",
  "jv.planProfitPctHint": "Profit as a percent of the cost incl. overhead. It follows the takeoff when the cost changes; type an amount instead to fix the figure.",
  "jv.planEscalationRow": "Escalation allowance",
  "jv.planEscalationSub": "added last: no overhead or profit on it",
  "jv.planEscalationHint": "An allowance for cost increases. It is added after overhead and profit, so neither is charged on it, and it counts as takeoff cost when the task is judged against its takeoff.",
  "jv.escalationNegative": "Escalation can't be negative — leave the box blank for none.",
  "jv.profitNegative": "Profit can't be negative — leave the box blank for none.",
  "jv.planNamedOverheadSub": "a cost group: direct cost, not the calculated overhead below",
  "jv.planPriceRow": "Price (cost + overhead + profit)",
  "jv.planPriceRowEsc": "Price (cost + overhead + profit + escalation)",
  "jv.planPriceVsContract": "vs contract {contract}",
  "jv.planMarginRow": "Takeoff margin",
  "jv.planMarginOf": "{pct}% of {contract}",
  "jv.finishBtn": "Mark finished",
  "jv.finishBtnTitle": "The task is done. A task with a contract value earns its full contract from the day it finished — what its progress had not reached goes in as profit. A task with no cap, a task with no price, or a credit keeps earning what its progress shows. Reopen takes it back.",
  "jv.finishedFull": "Finished {date} — earns its full {amt} (progress showed {was})",
  "jv.finishesFull": "Finishes {date} — earns its full {amt} from that day (progress shows {was})",
  "jv.finishMoves": "Finishing earns the remaining {amt}",
  "jv.finishConfirm": "Earned goes from {from} to {to} today. Mark finished?",
  "jv.finishedToast": "Marked finished: {name}",
  "jv.undoBtn": "Undo",
  "jv.pctFinishedTitle": "Finished — it earns its full contract. Reopen it to change its progress.",
  "jv.finishedBadge": "Finished",
  "jv.finishedDateAria": "Day {name} was finished",
  "jv.reopenBtn": "Reopen",
  "jv.overageWarn": "{qty} beyond approved scope — not earning",
  "jv.amountOpenPlaceholder": "No cap — no total",
  "jv.continuesLabel": "Adds to line",
  "jv.continuesStandaloneOpt": "(its own line)",
  "jv.continuesExcludesOpenHint": "Lines with no cap are not listed — they already earn everything installed themselves.",
  "jv.continuesNote": "Pays for {name} beyond its contract quantity",
  "jv.continuedByChip": "+ {name}",
  "pr.noProjectsTitle": "No projects yet",
  "pr.noProjectsHint": "Create a project first — production reports are filed against one.",
  "pr.archivedSuffix": " (archived)",
  "pr.emptyTitle": "No production reported on this project yet",
  "pr.emptyHint": "Quantities appear here as soon as your crews file a Production Report from the field.",
  "pr.installedToDate": "Installed to date",
  "pr.spanRange": "{from} – {to}",
  "pr.metaReports": "{n} reports",
  "pr.metaReportOne": "1 report",
  "pr.metaDays": "{n} days",
  "pr.metaDayOne": "1 day",
  "pr.metaCrews": "{n} crews",
  "pr.metaCrewOne": "1 crew",
  "pr.tileFoot": "on {n} days",
  "pr.tileFootOne": "on 1 day",
  "pr.contractNote": "These are the quantities {contract} earns from, and the same ones {jobcosts} prices subcontract labour against.",
  "pr.noteContractTab": "Contract",
  "pr.noteJobCostsTab": "Job Costs",
  "pr.noItemsTitle": "Nothing priceable reported",
  "pr.noItemsHint": "This project has production reports, but none of them record a production item, so none of it can reach the contract.",
  "pr.unknownItem": "Unidentified item",
  "pr.badgeUnknown": "Not in catalogue",
  "pr.reportsNote": "Newest first — what each crew filed, and the running total beside it",
  "pr.reportsTitle": "Day by day",
  "pr.runningTotal": "{total} to date",
  "pr.badgeSub": "Sub crew",
  "pr.whoUnknown": "Crew not recorded",
  "pr.rowNoItems": "No production items on this report",
  "pr.rowLegacy": "Retired format — not counted toward the contract",
  "pr.rowEmpty": "No quantities recorded",
  "pr.rowUncounted": "{qty} with no production item — not counted",
  "pr.openPdf": "Open the signed report",
  "pr.openPdfAria": "Open the signed report for {date}",
  "pr.noPdfTitle": "No PDF on file for this report",
  "pr.discTitle": "Some quantities on this project do not reach the contract",
  "pr.discHint": "Open the report below to see what was actually filed.",
  "pr.discUnknownOne": "1 item is not in your production catalogue, so no contract line can earn against its {qty}.",
  "pr.discUnknownMany": "{n} items are not in your production catalogue, so no contract line can earn against their {qty}.",
  "pr.discNoItemOne": "1 entry records {qty} against no production item, so it is not counted.",
  "pr.discNoItemMany": "{n} entries record {qty} against no production item, so none of it is counted.",
  "pr.discLegacyOne": "1 report stores its quantities in a retired format: it still prices subcontract labour, but earns nothing on the contract.",
  "pr.discLegacyMany": "{n} reports store their quantities in a retired format: they still price subcontract labour, but earn nothing on the contract.",
  "pr.discEmptyOne": "1 report records no quantities at all.",
  "pr.discEmptyMany": "{n} reports record no quantities at all.",
  "prr.title": "{job} · Production Report",
  "prr.subtitle": "{item} installed per day · {range}",
  "prr.subtitleOne": "{item} installed · {date}",
  "prr.tileTotal": "{item} installed",
  "prr.tileDays": "Working days reported",
  "prr.tileDaysOne": "Working day reported",
  "prr.tileAvg": "Per working day, project average",
  "prr.tileRecent": "Per working day, last 4 weeks ({range})",
  "prr.tileRecentShort": "Per working day, last 4 weeks (covers every report)",
  "prr.tileBest": "Best day · {date}",
  "prr.tileBestTied": "Best day · {date} (tied, {n} days)",
  "prr.headline": "The four weeks to {to} averaged {recent} per working day, {cmp} the project average of {avg}{trend}.",
  "prr.headlineShort": "{days} working days reported, averaging {avg} per working day. The reports span less than four weeks, so there is no trend to compare.",
  "prr.headlineOne": "One working day reported: {qty} on {date}.",
  "prr.cmp_above": "above",
  "prr.cmp_below": "below",
  "prr.cmp_equal": "in line with",
  "prr.trendUp": " and up from a low of {v} in {when}",
  "prr.trendDown": " and down from a high of {v} in {when}",
  "prr.when": "{part} {month}",
  "prr.early": "early",
  "prr.mid": "mid",
  "prr.late": "late",
  "prr.legend": "Bars: quantity installed each working day. Red line: trailing 4-week average per working day. Dashed: project average ({avg}).",
  "prr.legendShort": "Bars: quantity installed each working day. Dashed: project average ({avg}).",
  "prr.avgLabel": "{v} project average",
  "prr.recentLabel": "{v} last 4 weeks",
  "prr.gapNone": "no reports",
  "prr.gapItem": "not reported",
  "prr.byMonth": "By month",
  "prr.byWeek": "By week · installed",
  "prr.notes": "Notes",
  "prr.colMonth": "Month",
  "prr.colDays": "Working days",
  "prr.colQty": "Installed",
  "prr.colQtyUnit": "Installed ({unit})",
  "prr.colPerDay": "Per day",
  "prr.total": "Total",
  "prr.noteBestWeek": "Best week:",
  "prr.noteBestWeekText": "{range}, {qty}.",
  "prr.noteBestDay": "Best day:",
  "prr.noteBestDayText": "{date}, {qty}.",
  "prr.noteBestDays": "Best days:",
  "prr.noteBestDaysText": "{dates}, {qty} each.",
  "prr.noteBestDayMany": "{qty}, reached on {n} days (first {date}).",
  "prr.noteRecent": "Last 4 weeks:",
  "prr.noteRecentText": "{qty} in {days} ({range}), {cmp}.",
  "prr.oneWorkingDay": "1 working day",
  "prr.nWorkingDays": "{n} working days",
  "prr.noteCmp_above": "{pct}% above the project average",
  "prr.noteCmp_below": "{pct}% below the project average",
  "prr.noteCmpEqual": "in line with the project average",
  "prr.noteGap": "Reporting gap:",
  "prr.noteGaps": "Reporting gaps:",
  "prr.noteGapText": "{list}; those days are not counted as working days.",
  "prr.gapNoteNone": "no production reports were filed {range}",
  "prr.gapNoteItem": "{item} was not reported {range}",
  "prr.noteSource": "Counts come from {n} daily production reports.",
  "prr.noteSourceOne": "Counts come from 1 daily production report.",
  "prr.noteWorkingDay": "A working day is any day with a report.",
  "prr.noteWorkingDayRun": "A working day is any day with a report ({days}).",
  "prr.metaJob": "Job",
  "prr.metaSite": "Site",
  "prr.metaGc": "GC",
  "prr.metaForeman": "Foreman",
  "prr.metaForemen": "Foremen",
  "prr.metaCrews": "{n} crews",
  "prr.metaIssued": "Issued",
  "prr.download": "Download PDF",
  "prr.itemsAria": "Production items in the report",
  "prr.emptyTitle": "No production to report on this project yet",
  "prr.emptyHint": "The report appears as soon as a crew files a Production Report with quantities on this project.",
  "prr.kidsTitle": "No production filed on this project itself",
  "prr.kidsHintOne": "Its crews file on its sub-project, {names}. Open it to see its production report.",
  "prr.kidsHint": "Its crews file on its {n} sub-projects ({names}). Open one to see its production report.",
  "prr.noJobTitle": "Open a project to see its production report",
  "prr.noJobHint": "Pick a project on Home — its Production chart tab shows what went in, day by day.",
  "prr.pdfFailed": "PDF library failed to load. Try a hard refresh.",
  "prr.downloaded": "{file} downloaded",
  "jc.recipeBadge": "Recipe",
  "jc.recipeRowSub": "{qty} {unit} installed · {cost} per unit",
  "jc.recipeRowNoRecipeSub": "{qty} {unit} installed — no recipe on file, so this costs nothing yet",
  "jc.recipeNoRecipe": "No recipe",
  "jc.recipeUnknownItem": "Item no longer in your catalogue",
  "jc.recipeGapOne": "1 item is not fully priced",
  "jc.recipeGapMany": "{n} items are not fully priced",
  "jc.methodRecipeNote": "This project costs material from its recipe. Deliveries and costs you added under Material are kept below for the record and are not counted.",
  "jc.methodRecipeNoteOther": "This project costs material from its recipe. Delivered items that no recipe line names count too, under Delivered items not in a recipe, at your price-book prices. The rest of each delivery, and costs you added under Material, are kept below for the record and are not counted.",
  "jc.methodOpenRecipes": "Edit recipe",
  "jc.noRecipeProduction": "No production reported on this project yet, so the recipe has nothing to cost.",
  "cx.noProjectsTitle": "No projects yet",
  "cx.noProjectsHint": "Add a project first — a recipe belongs to a project.",
  "cx.archivedSuffix": " (archived)",
  "cx.itemsTitle": "What each production item uses",
  "cx.itemsHint": "The catalogue items each production item uses. A delivered item goes by default to the task that measures the production item using it — unless a task is picked for it above.",
  "cx.noItemsTitle": "No production items yet",
  "cx.noItemsHint": "Add the items your crew reports building on Rates & Defaults, then come back to say which catalogue items each one uses.",
  "cx.itemInstalled": "{qty} {unit} installed on this project",
  "cx.itemNotInstalled": "Nothing installed on this project yet",
  "cx.itemTask": "Files to {task}",
  "cx.itemUsesOne": "Uses 1 item",
  "cx.itemUsesMany": "Uses {n} items",
  "cx.showIdleOne": "Show 1 more item — nothing installed on this project yet",
  "cx.showIdleMany": "Show {n} more items — nothing installed on this project yet",
  "cx.hideIdle": "Hide the items with nothing installed",
  "cx.otherTitle": "Delivered items",
  "cx.otherEmpty": "Nothing has arrived on this project yet. Each item delivered or picked up is listed here, with the task its cost goes to.",
  "cx.otherCountOne": "1 item",
  "cx.otherCountMany": "{n} items",
  "cx.otherHint": "Material costs what came in: each delivery and pickup, at your price-book price, on the day it arrived. Each item goes to the task in its box — the one picked here, else its default: the task that measures the production item using it (below), else the project’s only task, else General. Choose “Not a cost” for an item that is paid some other way — scaffold billed on Rentals, say: it stays on this list, marked, and is left out of every total.",
  "cx.otherShort": "Every item that arrived on this project, and the task its cost goes to on Job Costs.",
  "cx.otherAmbiguous": "Name fits more than one catalogue item",
  "cx.otherNotInCatalogue": "Not in your catalogue",
  "cx.otherTaskNote": "Pick the task once per item: it files every delivery of that item on this project — the ones a whole order was filed under on Job Costs and the ones still to come too — with its sales tax. Only a task picked on Job Costs for that one line of a delivery still wins for that line.",
  "cx.otherTaskShort": "Pick the task once per item — it files every delivery of that item.",
  "cx.otherSelectAria": "Select {name}",
  "cx.otherSelectAll": "Select all {n} items",
  "cx.otherBulkPick": "For the selected items…",
  "cx.otherBulkTaskAria": "Choice for the selected items",
  "cx.otherFileBtn": "Apply to {n} selected",
  "cx.otherFiledOne": "Saved for 1 item.",
  "cx.otherFiled": "Saved for {n} items.",
  "cx.otherNotSaved": "Not saved — {msg}",
  "cx.otherKeptIs": "Filed on Job Costs",
  "cx.otherKeptSome": "Filed line by line on Job Costs under {tasks}: {n} of {m} deliveries. A task picked here files the rest.",
  "cx.otherKeptAll": "Filed line by line on Job Costs under {tasks}: every delivery so far. A task picked here files only deliveries still to come.",
  "cx.otherOrderFiled": "Filed with its order on Job Costs for {n} of {m} deliveries ({tasks}) until a task is picked here.",
  "cx.otherOrderFiledOne": "Its one delivery is filed with its order on Job Costs ({tasks}) until a task is picked here.",
  "cx.otherOrderFiledAll": "All {m} deliveries are filed with their orders on Job Costs ({tasks}) until a task is picked here.",
  "cx.otherBulkNoTask": "No task of its own (follows its order, else its default)",
  "cx.otherNotACost": "Not a cost",
  "cx.otherCountIt": "Count it",
  "cx.otherCountCol": "In cost",
  "cx.otherNotCountedTag": "Not counted",
  "cx.otherNotCountedOne": "1 not a cost",
  "cx.otherNotCountedMany": "{n} not a cost",
  "cx.otherNoRow": "this project could not be updated from your account",
  "cx.otherSplitBtn": "Split…",
  "cx.otherSplitAria": "Split {name} across tasks by percentage",
  "cx.otherSplitIs": "Split across tasks",
  "cx.otherSplitHint": "Each delivery of this item on this project is split across these tasks, unless that line of the delivery is filed on its own on Job Costs. The shares must add to 100%.",
  "cx.otherBlind": "Only items on delivered requests are listed. Anything typed as free text on a delivery, or an older size with no catalogue row, is not here and is not counted. Listed and marked: an item your catalogue does not hold — rented scaffold requested through Logistics, or a row deleted or renamed since the delivery. It adds nothing to Job Costs while your catalogue has no price for it; if it is paid some other way (scaffold billed on Rentals), set it to “Not a cost” so it never will. An item with no price on file adds nothing to Job Costs until it is priced on Rates & Defaults.",
  "cx.otherBlindShort": "Only items on delivered requests are listed here.",
  "cx.itemUnpriced": "{n} without price",
  "cx.noRecipeYet": "No items yet",
  "cx.colComponent": "Item",
  "cx.itemIncomplete": "{n} without an amount",
  "cx.pstAdded": "+ {pct}% PST",
  "cx.noPriceOnFile": "No price on file",
  "cx.unknownComponent": "Component no longer in your catalogue",
  "cx.typedTag": "Typed by hand — files no delivery",
  "cx.noComponentsYet": "Nothing added yet. Add the catalogue items this production item uses.",
  "cx.addComponent": "Add component",
  "cx.removeComponent": "Remove component",
  "cx.pickerTitle": "Add a component",
  "cx.pickerHint": "Pick from the same list your crew orders from.",
  "cx.pickerCount": "{n} items",
  "cx.pickerAllUsed": "Every item in your catalogue is already listed for this one.",
  "cx.noPack": "Your own items",
  "cx.dvColDelivered": "Delivered",
  "cx.errDuplicate": "That item is already listed here.",
  "cx.importFromProject": "Import from project…",
  "cx.importTitle": "Import from another project",
  "cx.importHint": "Copy which catalogue items this production item uses from a project that already lists them.",
  "cx.importNoSources": "No other project lists items for this one yet.",
  "cx.exportBtn": "Export to other projects",
  "cx.exportTitle": "Copy these recipes to other projects",
  "cx.exportHint": "Pick the production items and the projects. Each list goes across exactly as it is here.",
  "cx.exportWhat": "Recipes to send",
  "cx.exportWhere": "Send to",
  "cx.exportNoTargets": "This is your only project so far.",
  "cx.exportReplacesOne": "replaces 1",
  "cx.exportReplacesMany": "replaces {n}",
  "cx.exportPickBoth": "Pick at least one recipe and one project.",
  "cx.exportNRecipeOne": "1 recipe",
  "cx.exportNRecipeMany": "{n} recipes",
  "cx.exportNJobOne": "1 project",
  "cx.exportNJobMany": "{n} projects",
  "cx.exportSummary": "{a} to {b}",
  "cx.exportSummaryReplaces": "{n} will be replaced",
  "cx.exportGo": "Copy",
  "cx.exportSending": "Copying…",
  "cx.exportConfirm": "Copy {a} to {b}?",
  "cx.exportConfirmReplaces": "{r} already on those projects will be REPLACED by this one. This cannot be undone.",
  "cx.exportDone": "Copied {a} to {b}.",
  "cx.importLineCountOne": "1 item",
  "cx.importLineCountMany": "{n} items",
  "cx.importConfirm": "Replace the {n} items listed for {item} with the {m} from {project}?",
  "cx.importSourceEmpty": "That project lists nothing for this item now — nothing to import.",
  "cx.importFailed": "Import failed: {msg}. Nothing was changed.",
  "pnl.tab": "P&L",
  "pnl.colProject": "Project",
  "pnl.colContract": "Contract",
  "pnl.contractUncapped": "+ unit-price",
  "pnl.contractUncappedTip": "This project also has unit-price lines with no agreed total. They earn every unit installed, so Earned can be more than the contract.",
  "pnl.colEarned": "Earned",
  "pnl.colDirect": "Direct",
  "pnl.colOverhead": "Overhead",
  "pnl.colTotalCost": "Total cost",
  "pnl.colProfit": "Profit",
  "pnl.colMarginPct": "Margin %",
  "pnl.totalsLabel": "Totals",
  "pnl.showArchived": "Show archived ({n})",
  "pnl.hideArchived": "Hide archived",
  "pnl.archivedBadge": "Archived",
  "pnl.noActiveProjects": "No active projects — toggle \"Show archived\" to see the rest.",
  "pnl.noContractTooltip": "No contract lines yet — costs shown, revenue unpriced",
  "pnl.noRevenueTip": "No contract value on file yet — this cost is in the totals, and the project is not counted as a loss",
  "pnl.noRevenueFoot": "No contract value on file yet — the cost is below; there is no profit figure until revenue is entered",
  "pnl.noContractIncludedOne": "Totals include {amt} spent on 1 project with no contract yet. That cost lowers Profit and Margin above; the project is not counted as a loss.",
  "pnl.noContractIncludedMany": "Totals include {amt} spent on {n} projects with no contract yet. That cost lowers Profit and Margin above; those projects are not counted as a loss.",
  "pnl.backToPortfolio": "All projects",
  "pnl.jobToDate": "Project to date",
  "pnl.revenueEarned": "Revenue earned",
  "pnl.ofContract": "of {amt} · {pct} of contract",
  "pnl.noFixedContractFooter": "Priced by rate — no fixed contract total",
  "pnl.marginFoot": "profit as a share of revenue earned",
  "pnl.colGroup": "Group",
  "pnl.totalCost": "Total cost",
  "pnl.costGroupNote": "Direct groups, then overhead",
  "pnl.costGroupNotePeriod": "This period beside project to date",
  "pnl.byTaskNote": "Cost includes the {pct}% overhead · adds up to Total cost and Profit",
  "pnl.byTaskNoteNoOverhead": "Adds up to Total cost and Profit · same figures as Job Costs",
  "pnl.byTaskNoteCostOnly": "Cost includes the {pct}% overhead · adds up to Total cost",
  "pnl.byTaskNoteNoOverheadCostOnly": "Adds up to Total cost · same figures as Job Costs",
  "pnl.warnTitle": "Worth checking before you read these numbers",
  "pnl.costByGroupTitle": "Cost by group",
  "pnl.noCosts": "Nothing spent on this project yet.",
  "pnl.profitLabel": "Profit",
  "pnl.colTask": "Task",
  "pnl.colRevenueEarned": "Earned",
  "pnl.colCost": "Cost",
  "pnl.warnOverage": "{items} beyond approved scope — not earning",
  "pnl.warnUnpricedOne": "1 contract line has no rate — it earns $0 until a rate is set",
  "pnl.warnUnpricedMany": "{n} contract lines have no rate — they earn $0 until a rate is set",
  "pnl.warnGeneralShare": "{amount} of cost ({pct}) not assigned to a task",
  "pnl.warnBuildingsOne": "1 sub-project has items worth checking",
  "pnl.warnBuildingsMany": "{n} sub-projects have items worth checking",
  "pnl.toCheck": "{n} to check",
  "pnl.warnNotes": "Notes",
  "pnl.checkedOne": "1 warning marked correct (checked by {names})",
  "pnl.checkedMany": "{n} warnings marked correct (checked by {names})",
  "pnl.openJobCosts": "Open in Job Costs",
  "pnl.pdfBtn": "Download P&L (PDF)",
  "pnl.periodJobToDate": "Project to date",
  "pnl.periodThisMonth": "This month",
  "pnl.periodLastMonth": "Last month",
  "pnl.periodCustom": "Custom",
  "pnl.periodApply": "Apply",
  "pnl.periodFrom": "From",
  "pnl.periodTo": "To",
  "pnl.periodShowing": "Showing {from} – {to}",
  "pnl.periodPriced": "Priced with the rates, prices, recipes and overhead on file today, not the ones in force during the period — changing one restates earlier periods. A subcontract rate change dated inside the project prices only the work from its date.",
  "pnl.periodPricedSince": "Priced with the rates, prices, recipes and overhead on file today (last changed {date}), not the ones in force during the period — changing one restates earlier periods. A subcontract rate change dated inside the project prices only the work from its date.",
  "pnl.periodInvalid": "Pick a valid date range (from must not be after to).",
  "pnl.colThisPeriod": "This Period",
  "pnl.colJobToDate": "Project to Date",
  "pnl.warnJobToDate": "(project to date)",
  "pnl.buildings": "Sub-projects",
  "pnl.rollupHeadline": "All sub-projects + general",
  "pnl.ownBooksNote": "The figures below are this project's own books; each sub-project has its own statement.",
  "projects.buildings": "Sub-projects",
  "projects.addBuilding": "Add sub-project",
  "projects.buildingName": "Sub-project name",
  "projects.buildingsUnder": "Site location, GC and sub-projects for {name}",
  "projects.siteAndBuildings": "Site location, GC and sub-projects",
  "projects.archiveCascade": "This project has {n} sub-projects. Archiving it archives them too.",
  "projects.unarchiveCascade": "This project has {n} sub-projects. Reactivating it reactivates them too.",
  "projects.general": "— general",
  "projects.open": "Open",
  "projects.openTip": "Open {name} — costs, contract, production and documents",
  "projects.assignForemenTip": "Assign foremen to {name}",
  "projects.gapSafety": "No safety contact",
  "projects.gapSafetyTip": "Its safety forms only go to your company's safety address — add the CSO who should get them",
  "projects.gapLocation": "No location",
  "projects.gapLocationTip": "Without a site location, a time-clock check-in far from the project is never flagged",
  "projects.gapForeman": "No foreman",
  "projects.gapForemanTip": "Nobody can file a form or a timesheet on this project until a foreman is on it",
  "projects.gcLabel": "General contractor",
  "projects.gcPlaceholder": "GC company name",
  "projects.gcHint": "Prints on this project's change orders, RFIs and submittals.",
  "projects.gcSaved": "General contractor saved",
  "projects.gcCleared": "General contractor cleared",
  "projects.gcSaveFailed": "Could not save the general contractor: {msg}",
  "home.pulseEmpty": "No production reported in the last 8 weeks — the chart fills in from Production Reports.",
  "home.subCount": "{n} sub-project{s}",
  "home.pendingBadge": "{n} pending today",
  "home.noContractBadge": "No contract yet",
  "home.noContractIncluded": "incl. {amt} spent on {n} project{s} with no contract yet",
  "job.backToJobs": "All projects",
  "job.untitled": "Project",
  "job.tabOverview": "Overview",
  "job.tabJobCosts": "Job Costs",
  "job.tabContract": "Contract",
  "job.tabPnl": "P&L",
  "job.tabProduction": "Reports filed",
  "job.tabProductionReport": "Production chart",
  "job.tabByProject": "Forms & materials",
  "bp.folderTitle": "Show these forms",
  "bp.filesCount": "{n} filed",
  "bp.filesNone": "Nothing filed under this form yet.",
  "bp.filesError": "These forms could not be loaded. Try again.",
  "bp.weekOf": "Week of {date}",
  "job.tabCostRecipes": "Material by task",
  "job.tabDocuments": "Documents",
  "job.tabChecklist": "Checklist",
  "jov.noJobTitle": "Open a project to see its overview",
  "jov.noJobHint": "Pick a project on Home — its Overview shows who runs it, what was filed this week and what is waiting.",
  "jov.loadError": "This project's overview could not be loaded.",
  "jov.peopleTitle": "Crew & safety",
  "jov.crewTitle": "Foremen",
  "jov.crewNone": "No foreman assigned to this project yet.",
  "jov.crewAssign": "Assign foremen",
  "jov.safetyTitle": "Safety contact",
  "jov.safetyNone": "No safety contact — add one so the CSO gets this project's safety forms.",
  "jov.safetyNoneShort": "No safety contact",
  "jov.safetyAdd": "Add a safety contact",
  "jov.safetyEdit": "Change",
  "jov.formsTitle": "Forms filed",
  "jov.formsCount": "{today} today · {week} this week",
  "jov.formsToday": "Today",
  "jov.formsEarlier": "Earlier this week",
  "jov.formsNone": "Nothing filed on this project this week yet.",
  "jov.formsAll": "All forms & materials",
  "jov.formPdf": "Open the PDF",
  "jov.formNoPdf": "No PDF",
  "jov.signed": "Signed",
  "jov.received": "Received",
  "jov.waitTitle": "Waiting on you",
  "jov.waitNone": "No extra work or change orders waiting.",
  "jov.ewoSubmitted": "Submitted",
  "jov.ewoSent": "Sent to GC",
  "jov.coDraft": "Draft",
  "jov.coSent": "Sent",
  "jov.coUnnumbered": "Change order",
  "jov.openEwo": "Extra Work",
  "jov.openCo": "Change Orders",
  "jov.openRfi": "RFIs",
  "jov.delivTitle": "Open deliveries",
  "jov.delivNone": "No deliveries waiting on this project.",
  "jov.delivNeeded": "Needed {date}",
  "jov.delivNoDate": "No date set",
  "jov.delivRequested": "Requested",
  "jov.delivOnSchedule": "On schedule",
  "jov.delivOnHold": "On hold",
  "jov.delivOpen": "Deliveries",
  "jov.schedTitle": "Coming up",
  "jov.schedNone": "Nothing on the schedule for this project.",
  "jov.schedNow": "In progress",
  "jov.schedMore": "{n} more on the schedule",
  "jov.schedOpen": "Schedule",
  "ck.noProjectsTitle": "No projects yet",
  "ck.noProjectsHint": "Add a project first — a checklist belongs to a project.",
  "ck.inactiveSuffix": " (inactive)",
  "ck.progress": "{done} of {total} done",
  "ck.fromTemplate": "Started from the {pack} template — add or remove rows for this project.",
  "ck.noTemplate": "No template for this trade yet — add the rows this project needs.",
  "ck.empty": "Nothing on this checklist yet.",
  "ck.colItem": "Item",
  "ck.colIncluded": "Included?",
  "ck.colSpec": "Notes",
  "ck.colSupplier": "Supplier",
  "ck.colStatus": "Status",
  "ck.pick": "Select",
  "ck.yes": "Yes",
  "ck.no": "No",
  "ck.pending": "Pending",
  "ck.ready": "Ready",
  "ck.done": "Done",
  "ck.specPh": "Notes for this project — spec, size, material, supplier answers, decisions…",
  "ck.noSection": "Other",
  "ck.addItem": "Add item",
  "ck.addSection": "Add section",
  "ck.colSection": "Section",
  "ck.newSectionPrompt": "e.g. 10. Closeout",
  "ck.newItemPrompt": "e.g. Anchor bolts",
  "ck.remove": "Remove item",
  "ck.removeConfirm": "Remove \"{item}\" from this project's checklist?",
  "ck.lock": "Lock",
  "ck.unlock": "Unlock",
  "ck.lockedTag": "Locked",
  "ck.lockedToast": "Checklist locked — unlock it to make changes.",
  "ck.unlockedToast": "Checklist unlocked.",
  "ck.lastChange": "Last change: {name} · {when}",
  "ck.noChangesYet": "No changes yet.",
  "ck.someone": "Someone",
  "job.tabSchedule": "Schedule",
  "job.scheduleUnassignedNoteOne": "1 unassigned task lives on the global Schedule",
  "job.scheduleUnassignedNote": "{n} unassigned tasks live on the global Schedule",
  "job.scheduleMore": "⋯ More",
  "job.scheduleMoreTitle": "Rename, delete, lock, PDF, row order and zoom",
  "ewo.searchPlaceholder": "Search EWOs",
  "si.allProjects": "All projects",
  "si.backToJob": "Back to {name}",
  "si.allFoot": "every active project",
  "si.allJobs": "Projects",
  "si.allJobsFoot": "with change orders",
  "si.allHint": "Every active project's change orders. Tap one to open it in its project, or pick a project above to create one.",
  "si.allEmpty": "No change orders on any active project yet — pick a project above to create one.",
  "si.allLoadError": "Change orders could not be loaded. Check your connection and try again.",
  "rfi.allProjects": "All projects",
  "rfi.allHint": "Every active project's RFIs. Tap one to open it, or pick a project above to write a new one.",
  "rfi.allEmpty": "No RFIs on any active project yet — pick a project above to write one.",
  "rfi.allLoadError": "RFIs could not be loaded. Check your connection and try again.",
  "rfi.allFoot": "every active project",
  "sub.missingPairsOne": "1 missing pair in the last 4 weeks — {list}",
  "sub.missingPairsMany": "{n} missing pairs in the last 4 weeks — {list}",
  "sub.missingPairsMore": "and {k} more",
  "home.kpiShown": "{n} project{s} shown",
  "home.kpiShownSub": "{n} project{s} shown ({m} incl. sub-projects)",
  "home.kpiMargin": "Blended margin",
  "home.kpiFiled": "Filed today",
  "home.kpiFiledFoot": "Tailgates · each site with a foreman",
  "home.jobsAtLoss": "{n} project{s} at a loss",
  "home.noJobsAtLoss": "No project at a loss",
  "home.activeJobs": "Active projects",
  "home.colJob": "Project",
  "home.colThisWeek": "This week",
  "home.legendPending": "Tailgate pending",
  "home.legendFiled": "Filed today",
  "home.total": "Total · {n} project{s}",
  "home.crewCount": "{n} foremen",
  "home.crewCountOne": "1 foreman",
  "home.noCrew": "no foreman assigned",
  "home.buildingOf": "Sub-project of {name}",
  "home.generalOf": "{name}'s own books — in none of its sub-projects",
  "home.noMatches": "No project matches that search.",
  "home.pulsePer": "{unit} per week · {n} site{s} reporting",
  "home.units": "units",
  "home.eightWeekTotal": "8-week total",
  "home.searchPlaceholder": "Search projects or sites",
  "home.sortProfit": "Sort: Profit",
  "home.sortMargin": "Sort: Margin",
  "home.sortEarned": "Sort: Earned",
  "home.sortWeek": "Sort: This week",
  "home.sortName": "Sort: Name",
  "home.emptyTitle": "No projects yet",
  "home.emptyHint": "Each project shows up here once it exists — this week's production, who has filed today, and what it is earning.",
  "home.emptyCta": "Create your first project",
  "onboard.step1": "Add your logo and province",
  "onboard.step1Hint": "Your logo prints on every PDF; the province decides which regulator your inspection forms cite.",
  "onboard.step1NeedsProvince": "Logo is in — now pick your province under Jurisdiction and save.",
  "onboard.step1NeedsLogo": "Province is set — now upload your logo.",
  "onboard.step1Btn": "Open Settings",
  "onboard.step2": "Create your first project",
  "onboard.step2Hint": "Every form, timesheet and delivery is filed against a project.",
  "onboard.step2Btn": "Create project",
  "onboard.step3": "Invite a foreman and give them the project",
  "onboard.step3Hint": "Foremen file the forms in the field. They only see the projects you give them.",
  "onboard.step3Waiting": "Invite sent — waiting for {email}",
  "onboard.step3Joined": "{name} joined — give them a project",
  "onboard.step3Btn": "Invite a foreman",
  "onboard.step4": "Add your workers — they don't need a login",
  "onboard.step4Hint": "Foremen pick them for signatures and hours. Workers are always free.",
  "onboard.step4Btn": "Add workers",
  "onboard.step5": "File your first tailgate",
  "onboard.step5Hint": "Open the field app, pick the project and file a Daily Tailgate — it lands here as a signed PDF.",
  "onboard.step5Btn": "Open the field app",
  "onboard.step5Done": "{type} filed {date}",
  "onboard.step5View": "View it",
  "pnl.periodAria": "Reporting period",
  "pnl.tableTitle": "Every project",
  "pnl.tableHint": "Click a project for its statement · a project with sub-projects expands into them",
  "pnl.rollupNote": "A project’s row already includes its sub-projects — expanding shows where the money sits, never adds it twice. Contract is the whole project’s value, whatever period you pick.",
  "pnl.kpiJobs": "{n} project{s} shown",
  "pnl.kpiOfContract": "{pct} of contract earned",
  "pnl.kpiOfContractPeriod": "{pct} of contract earned in this period",
  "pnl.kpiCostSplit": "{direct} direct + {overhead} overhead",
  "pnl.kpiMargin": "margin {pct}",
  "pnl.kpiAtLoss": "{n} at a loss",
  "job.switchJob": "Switch project",
  "job.switchActive": "Active projects",
  "job.switchArchived": "Archived",
  "jc.pickedUp": "Picked up",
  "jv.staleBadge": "Source not approved",
  "jv.staleCoTitle": "The change order behind this line is no longer approved. It is still counted as contract value — remove the line if it should not be.",
  "jv.staleEwoTitle": "The extra work order behind this line is no longer approved. It is still counted as contract value — remove the line if it should not be.",
  "crew.lblCrew": "Crew",
  "crew.lblOnSiteToday": "On site today",
  "crew.lblRemaining": "Remaining",
  "crew.lblUsed": "Used",
  "certs.swipeHint": "Swipe sideways to see all {n} certificates",
  "proj.lblForemen": "Foremen",
  "prodUnit.short.sf": "sq ft",
  "prodUnit.short.lf": "lin ft",
  "prodUnit.short.m2": "sq m",
  "prodUnit.short.lm": "m",
  "prodUnit.short.cy": "cu yd",
  "prodUnit.short.m3": "cu m",
  "prodUnit.short.pcs": "pcs",
  "prodUnit.short.hr": "hrs",
  "prodUnit.name.sf": "square feet",
  "prodUnit.name.lf": "linear feet",
  "prodUnit.name.m2": "square metres",
  "prodUnit.name.lm": "metres",
  "prodUnit.name.cy": "cubic yards",
  "prodUnit.name.m3": "cubic metres",
  "prodUnit.name.pcs": "pieces",
  "prodUnit.name.hr": "hours",
  "prodUnit.dim.area": "area, not pieces",
  "prodUnit.dim.length": "length, not pieces",
  "prodUnit.dim.volume": "volume, not pieces",
  "prodUnit.withDim": "{name} ({dim})",
  "prodUnit.perDay": "{name} per day",
  "prodOutlier.title": "Check this number",
  "prodOutlier.day": "{day}: {msg}",
  "prodOutlier.max": "{qty} {unit} in one day is more than any day your company has reported for {item} (max {max}).",
  "prodOutlier.maxOwn": "{qty} {unit} in one day is more than any day you have reported for {item} (max {max}).",
  "prodOutlier.median": "{qty} {unit} in one day is more than {factor} times a usual day for {item} (usually {median}).",
  "prodOutlier.askMeasured": "Did you count pieces instead of {name}?",
  "prodOutlier.askCounted": "Check the number before you send it.",
  "prodOutlier.fix": "Fix it",
  "prodOutlier.ok": "It's right",
  "guard.dateMissing": "Please select a date.",
  "guard.futureDate": "Date can't be in the future — today is {today}.",
  "guard.rowN": "Row {n}",
  "guard.tsNoEmployee": "Row {n}: pick the employee before entering hours.",
  "guard.tsNegative": "{name}'s {day} has negative hours.",
  "guard.tsOver24": "{name}'s {day} has {h}h — a day has at most 24.",
  "guard.tsFutureConfirm": "These hours are on days that have not happened yet:\n{list}\n\nFile the timesheet anyway?",
  "guard.ewoNoWorker": "Labour row {n}: pick the employee before entering hours.",
  "guard.ewoNegative": "{name} has negative hours on this extra work order.",
  "guard.ewoOver24": "{name} has {h}h on this extra work order — a day has at most 24.",
  "guard.ewoNoLines": "Add the labour hours or the materials for this extra work before signing.",
  "guard.weekMismatch": "{label} ({typed}) is not in the week of the Date ({from} to {to}). Set the Date to a day in the week you are reporting, or fix {label}.",
  "guard.certIssuedMissing": "Please enter the issued date.",
  "guard.certIssuedFuture": "The issued date can't be in the future — today is {today}.",
  "guard.certExpiryMissing": "Please enter the expiry date.",
  "guard.certExpiryBeforeIssued": "The expiry date must be on or after the issued date.",
  "guard.noSignal": "No signal — your entries are kept on this screen. Tap the button again when you are connected.",
  "guard.pickupFuture": "A pickup can't be dated in the future — today is {today}.",
  "guard.neededByPastConfirm": "The date you need this by ({date}) has already passed. Send the request anyway?",
  "deliv.sendRequest": "Send request",
  "deliv.recordPickup": "Record pickup",
  "deliv.lineOne": "1 line",
  "deliv.lineMany": "{n} lines",
  "deliv.sending": "Sending…",
  "deliv.saving": "Saving…",
  "deliv.queuedToast": "No signal — saved on this device. It sends by itself when you're back online.",
  "deliv.queuedHeader": "Saved on this device · {n}",
  "deliv.queuedPill": "Waiting to send",
  "deliv.queuedCancel": "Don't send",
  "deliv.queuedCancelConfirm": "Don't send this? It is removed from this device.",
  "deliv.historyUnavailable": "Your recent list can't load right now — check your signal.",
  "deliv.draftRestored": "Not sent yet — restored from this device.",
  "deliv.draftClear": "Clear",
  "deliv.draftClearConfirm": "Clear everything typed on this screen?",
  "deliv.slipTitle": "Send packing slip",
  "deliv.slipMode": "Packing slip",
  "deliv.slipHint": "Material arrived without a request? Snap the slip — the office enters the items.",
  "deliv.slipWhen": "When did it arrive?",
  "deliv.slipNeedsPhoto": "Add a photo of the packing slip.",
  "deliv.slipSentToast": "Packing slip sent — the office will enter it.",
  "deliv.slipWaiting": "Waiting for office",
  "deliv.slipFeedLabel": "Packing slip — waiting for office",
  "deliv.slipBadge": "To enter",
  "deliv.slipQueueTitle": "Slips to enter · {n}",
  "deliv.slipQueueNote": "material that arrived without a request — type in what is on the slip",
  "deliv.slipEnter": "Enter items",
  "deliv.slipNotMaterial": "Not material",
  "deliv.slipDismissConfirm": "Remove this packing slip? Use this when the photo is not material for a project. This cannot be undone.",
  "deliv.slipGone": "This slip was already entered or removed.",
  "deliv.slipEntryTitle": "Enter packing slip",
  "deliv.slipEntryHint": "Type what is on the slip. It is saved as picked up on the day it arrived and counts on the project cost.",
  "deliv.slipSupplier": "Supplier",
  "deliv.slipSaveBtn": "Save as picked up",
  "deliv.slipSaved": "Saved as picked up — it is on the project cost.",
  "deliv.slipNeedsItems": "Add at least one item from the slip.",
  "deliv.slipNeedsDate": "Pick the day it arrived.",
  "deliv.slipPage": "Packing slip page {n}",
  "deliv.slipPagesMany": "{n} pages",
  "deliv.itemTaskAria": "Task for {item}",
  "deliv.itemTaskHint": "The task is the item's on this project: it files every delivery of the item there.",
  "deliv.itemTaskSplit": "Split across tasks",
  "deliv.itemTaskByLine": "Filed on Job Costs for this delivery — change it there.",
  "deliv.itemTaskNotSaved": "Saved — but the task could not be saved: {msg}",
  "guard.draftSavedNoPhotos": "Progress saved — photos are not kept in drafts, add them again before submitting.",
  "guard.draftHadPhotos": "This draft had {n} photo(s) — photos are not kept in drafts, add them again before submitting.",
  "guard.tsOpenPunch": "{name}'s {day} is still checked in — set an end time before signing.",
  "guard.tsAddClockedWorkers": "{list} clocked hours on this project this week but are not on this sheet. File without them?",
  "guard.prodFutureDays": "This report has quantities on days that have not happened yet (week of {week}). Change the Date at the top of this form to a day in the week you are reporting.",
  "guard.prodFutureDaysBack": "This report has quantities on days that have not happened yet (week of {week}). Go back and change the Date at the top of the form to a day in the week you are reporting.",
  "tc.tab": "Time",
  "tc.viewOnsite": "On site now",
  "tc.onSite": "{n} on site",
  "tc.inAt": "in {time}",
  "tc.breakSince": "on break since {time}",
  "tc.openSince": "open since {day} {time}",
  "tc.byName": "by {name}",
  "tc.gpsOk": "GPS ok",
  "tc.gpsFar": "{km} km",
  "tc.print": "Print",
  "tc.onlineOnly": "Live view — needs a connection.",
  "tc.addOut": "Add missing check-out",
  "tc.fixTime": "Fix a time",
  "tc.breakMin": "Break (min)",
  "tc.reason": "Reason",
  "tc.save": "Save",
  "tc.correctReason": "Reason (required)",
  "tc.updated": "Updated {time}",
  "tc.off": "Time clock is off in Settings.",
  "tc.noProjects": "No active projects.",
  "tc.loadFailed": "Couldn't load who is on site — check your connection.",
  "tc.kindIn": "Check in",
  "tc.kindOut": "Check out",
  "tc.kindBreakStart": "Start break",
  "tc.kindBreakEnd": "Resume work",
  "tc.lineCorrected": "Corrected by {name}: {reason}",
  "tc.noPunches": "No punches on this day.",
  "tc.nothingChanged": "Nothing changed.",
  "tc.saveFailed": "Couldn't save this change. Try again.",
  "tc.dayLoadFailed": "Couldn't load this day. Try again.",
  "tc.errOutBeforeIn": "The check-out must be after the check-in.",
  "tc.errShiftOpen": "Add the missing check-out first, then the break.",
  "tc.errBreakOrder": "The break must end after it starts.",
  "tc.errNegativeBreak": "Break (min) must be 0 or more.",
  "tc.errStaleTarget": "That punch changed — close and reopen the day.",
  "tc.errDateTooFar": "Pick a time within one day of the work day.",
  "tc.errReason": "Add a reason for this change.",
  "tc.lineCorrectedNoName": "Corrected: {reason}",
  "tc.fixDayFor": "Fix this day for {name}",
  "tc.viewWeeks": "Weeks",
  "tc.weekOf": "Week of {from} – {to}",
  "tc.approveAll": "Approve all signed",
  "tc.export": "Export for QuickBooks",
  "tc.nothingToExport": "Nothing to export — no approved hours in this week.",
  "tc.heldBack": "{n} employees held back — {names}: hours on {project} not approved",
  "tc.heldBackUnknown": "{names}: hours on {project} with no worker on file",
  "tc.alreadyExported": "Already exported {date} — QuickBooks importers don't detect duplicates",
  "tc.confirmDownloaded": "Both files saved (Payroll Summary and Time Detail)? OK marks this week as exported (v{n}). Cancel leaves it unmarked so you can export again.",
  "tc.rowLimit": "QuickBooks Time imports at most 750 rows per file — split the Time Detail file if you use that path.",
  "tc.approve": "Approve",
  "tc.reopen": "Reopen",
  "tc.final": "Final · {date}",
  "tc.signed": "Signed {day} {time}",
  "tc.notSigned": "Not signed yet",
  "tc.workers": "{n} workers",
  "tc.worker1": "1 worker",
  "tc.hours": "{h} h",
  "tc.ot": "OT {h}",
  "tc.gpsCount": "{n} GPS",
  "tc.notOnSheet": "{n} not on a sheet",
  "tc.reopenReason": "Why are you reopening this week?",
  "tc.errOpenPunch": "Someone is still checked in that week — set an end time first.",
  "tc.errNotSynced": "{name}'s sheet is not synced — open the field app online.",
  "tc.weekClosed": "This week is payroll-final. Reopen it first.",
  "tc.approvedSummary": "{ok} approved, {failed} refused",
  "tc.approvedAll": "{ok} approved",
  "tc.weekEmpty": "No hours, punches or signed timesheets this week.",
  "tc.weekLoadFailed": "Couldn't load this week — check your connection.",
  "tc.flagOpen": "Open punch",
  "tc.flagDiff": "Sheet ≠ clock",
  "tc.flagFar": "GPS far",
  "tc.flagCorrected": "Corrected by {name}",
  "tc.flagSickMissing": "Approved sick not on sheet",
  "tc.flagNoSheet": "Punched, not on any sheet",
  "tc.flagTwoSheets": "On 2 sheets",
  "tc.flagSickTwoSheets": "Sick day on 2 sheets",
  "tc.flagEdited": "Edited by admin · {reason}",
  "tc.flagSkew": "Clock skew",
  "tc.flagLong": "Long shift",
  "tc.correct": "Correct payroll hours",
  "tc.correctR": "Regular hours (R)",
  "tc.correctOt": "Overtime hours (OT)",
  "tc.correctStale": "Nothing was changed — the hours were re-filed since this drawer opened. Close and reopen the week.",
  "tc.errHours": "Enter the hours as a number, 0 or more.",
  "tc.cellHours": "R {r} / OT {ot}",
  "tc.cellClock": "Clock {time}",
  "tc.cellClockHours": "Clock {time} · {h} h",
  "tc.signedPdf": "Signed PDF",
  "tc.payrollMeta": "Payroll",
  "tc.payrollFinal": "Final · {date} by {name}",
  "tc.payrollOpen": "Open",
  "tc.approveForPayroll": "Approve for payroll",
  "tc.reopenFirst": "Reopen the week first — this week is payroll-final.",
  "tc.viewOff": "Time off",
  "tc.pending": "Waiting for a decision",
  "tc.approved": "Approved",
  "tc.denied": "Denied",
  "tc.sick": "Sick",
  "tc.vacation": "Vacation",
  "tc.deny": "Deny",
  "tc.history": "History",
  "tc.days": "{n} days",
  "tc.day1": "1 day",
  "tc.offEmpty": "No time-off requests waiting.",
  "tc.offLoadFailed": "Couldn't load the time-off requests — check your connection.",
  "tc.refileDropsCorrection": "This week's hours were corrected for payroll. Re-filing rebuilds them from the signed sheet and drops those corrections.",
  "sd.futureDate": "A sick day can't be dated in the future — today is {today}.",
  "sd.duplicate": "A sick day is already logged for {name} on {date}.",
  "sd.subOne": "1 paid day a calendar year (set in Settings › General). Half-days count as 0.5. In-house employees only — subcontractor crews and admins don't accrue.",
  "sd.subMany": "{n} paid days a calendar year (set in Settings › General). Half-days count as 0.5. In-house employees only — subcontractor crews and admins don't accrue.",
  "sd.noneTakenOne": "the 1 paid day still available",
  "sd.noneTakenMany": "all {n} paid days still available",
  "sd.usedAllNone": "Nobody has used all {n} paid days",
  "sd.usedAllOne": "1 has used all {n} paid days",
  "sd.usedAllMany": "{k} have used all {n} paid days",
  "sd.usedAllNoneOne": "Nobody has used their 1 paid day",
  "sd.usedAllOneOne": "1 has used their 1 paid day",
  "sd.usedAllManyOne": "{k} have used their 1 paid day",
  "jc.entryFutureDate": "The date can't be in the future — today is {today}.",
  "jc.entryNotSaved": "Nothing was changed — the entry may have been removed. Reloading.",
  "ca.duePastConfirm": "The due date ({date}) is already in the past — the action would be born overdue. Create it anyway?",
  "crew.assignSaveFailed": "Could not save the assignments: {msg}",
  "crew.joinedNoProjectsOne": "{name} joined — no projects yet",
  "crew.joinedNoProjectsMany": "{n} foremen have no projects yet",
  "crew.joinedNoProjectsSub": "A foreman can't file a form or a timesheet until you give them a project.",
  "crew.assignProjects": "Assign projects",
  "crew.assignForemen": "Assign foremen",
  "crew.foremenOnTitle": "Foremen on {name}",
  "crew.noForemenYet": "No foremen yet — invite one first, then give them this project.",
  "crew.foremenLoadFailed": "Couldn't load the foremen — check your connection and try again.",
  "crew.inviteForeman": "Invite a foreman",
  "deliv.statusFailed": "Could not change the status: {msg}",
  "deliv.statusNoRow": "Nothing was changed — reloading.",
  "eq.transferAlreadyReviewed": "This request was already reviewed.",
  "eq.transferStatusFailed": "Could not update the request: {msg}",
  "eq.transferMoveFailed": "Cannot approve — {msg}",
  "crew.tradeRenameFailed": "Trade rename {from} → {to} failed: {msg}. Check the Workers and Pay Rates tabs before saving again.",
  "docs.deleteFailed": "Could not delete the document: {msg}",
  "docs.fileRemoveFailed": "The document was deleted, but its file could not be removed from storage: {msg}",
  "ewoRates.saveFailed": "Could not save {what}: {msg}",
  "ewoRates.partialFailed": "Saved, but {n} row(s) failed:\n{list}",
  "ewoRates.classNameEmpty": "Every classification needs a name.",
  "ewoRates.classNameDuplicate": "There is already a classification called “{name}”. Use a different name.",
  "ewoRates.loadFailed": "Could not load the rate sheet. Check your connection and try again.",
  "sch.stageEndBeforeStart": "Stage {n}: end date must be on or after the start date.",
  "sch.addTo": "Add tasks to",
  "sch.addToTitle": "The schedule new tasks for this project are added to",
  "sch.scopeNote": "This project, from every schedule",
  "field.notANumber": "{label}: enter a number.",
  "field.negative": "{label} can't be negative.",
  "field.belowMin": "{label} can't be less than {min}.",
  "field.stepOf": "Step {n} of {total}",
  "common.saved": "Saved",
  "common.copyLink": "Copy link",
  "common.copied": "Copied ✓",
  "common.copyFailed": "Select the link and copy it",
  "nav.adminOnly": "That page is for admins — you're back on Today.",
  "start.setupTitle": "Set up your company",
  "start.setupSub": "Five steps to your first signed tailgate. Each one opens the Admin panel at the right place.",
  "start.stepBrand": "Add your logo and province",
  "start.stepProject": "Create your first project",
  "start.stepForeman": "Invite a foreman and put them on the project",
  "start.stepWorkers": "Add your workers",
  "start.stepTailgate": "Run your first tailgate",
  "start.stepTailgateSub": "Right here on Today, once the project exists.",
  "start.noJobTitle": "You're not on a project yet",
  "start.noJobSub": "Ask your office to add you — they can see you're waiting.",
  "cso.none": "No safety officer set for this project — your office still gets the PDF.",
  "cso.addLink": "Add safety contact",
  "cso.unknown": "No signal — couldn't check this project's safety officer. Your office still gets the PDF.",
  "done.sent": "Sent to the office. It's in My submissions.",
  "done.unconfirmed": "This phone couldn't confirm it reached the office, so the PDF is saved here. Check My submissions in a few minutes.",
  "done.safetySent": "Safety email sent to {n} recipient{s}{extra}.",
  "done.safetyPending": "The safety email goes out within 15 minutes.",
  "done.offlineTitle": "Saved on this phone",
  "done.offlineMsg": "It will send when you have signal.",
  "done.localCopy": "Copy on this phone:",
  "done.refused": "Saved on this phone — the server refused it. Show your admin. Need help? Text 604 722 0685.",
  "nav.helpVideos": "Help & videos",
  "nav.textSupport": "Text support 604 722 0685",
  "nav.contractsHint": "Contract value is set per project —",
  "nav.contractsHintLink": "open a project",
  "nav.attnTitle": "Needs attention",
  "nav.attnNone": "Nothing needs attention right now.",
  "nav.attnEwoOne": "1 EWO to price",
  "nav.attnEwoMany": "{n} EWOs to price",
  "nav.attnTransferOne": "1 equipment transfer to approve",
  "nav.attnTransferMany": "{n} equipment transfers to approve",
  "nav.attnSlipsOne": "1 packing slip to enter",
  "nav.attnSlipsMany": "{n} packing slips to enter",
  "safety.salusReveal": "We use Salus Pro",
  "certs.staffOnly": "Only your foreman or admin can add certificates.",
  "mysubs.photosOnly": "Photos",
  "projects.addedToast": "Project added — next: set its safety contact and assign a foreman.",
  "crew.workerAddedToast": "Worker added: {name}",
  "crew.certsAppliedToast": "Certification saved for {n} worker(s)",
  "jv.lineAddedToast": "Line added to the contract",
  "dm.addedToast": "Added to the catalogue: {name}",
  "dm.groupRenamedToast": "Group renamed: {name}",
  "rt.payInvalid": "Not saved. Type a rate of 0 or more — the box is back to the stored rate.",
  "rt.numInvalid": "Not saved. Type a number of 0 or more — the box is back to the stored value.",
  "rt.saveFailed": "Not saved: {msg}"
}
